import { ref as W, computed as q, reactive as Lt, watch as we, onBeforeMount as kr, onUnmounted as Mr, nextTick as st, defineComponent as Ke, createElementBlock as ye, openBlock as te, normalizeStyle as Ut, createElementVNode as Q, normalizeClass as xe, withDirectives as At, createVNode as le, toDisplayString as lt, withCtx as rt, withModifiers as Ht, vShow as sr, renderSlot as nt, createBlock as kt, createCommentVNode as at, unref as $, onMounted as Kt, h as Ne, getCurrentInstance as ln, shallowRef as un, isRef as ke, isReactive as lr, isVNode as cn, createApp as ur, createSlots as dn, mergeProps as cr } from "vue";
import { _ as jt } from "./Icon.ce.vue_vue_type_script_setup_true_lang-CdOC0ycX.js";
import { _ as Wt } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
import { _ as fn } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import { _ as Gt } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import pn from "./StatusSelect.js";
import { D as K } from "./luxon-BFLqgYPH.js";
import vn from "./MainCalendar.js";
import mn from "./CalendarNavigationControl.js";
import { t as gn } from "./tooltip-YeSRTnG0.js";
/* empty css                                                                      */
/* empty css                                                                        */
/* empty css                                                                      */
import "./idb-35dVPy4g.js";
import "./SvgRender.js";
import "./icon-C5cGsR9k.js";
/* empty css                                                                  */
import "./OverflowTooltip.js";
/* empty css                                                                    */
import "./Chip.js";
/* empty css                                                                  */
import "./main-Bh5cSLmY.js";
/* empty css                                                          */
import { a as Ue } from "./index-Ct-O5af5.js";
import "./debounce-BJrVv5jG.js";
/* empty css                                                                     */
/* empty css                                                                    */
import "./SearchInput.js";
import "./LoadMoreWrapper.js";
import "./Select-Dbr2pXH_.js";
/* empty css                                                                         */
/* empty css                                                                            */
/* empty css                                                                      */
/* empty css                                                                */
import "./Reaction.vue_vue_type_style_index_0_scoped_a67a1bb4_lang-WDRHCN3u.js";
/* empty css                                                                     */
/* empty css                                                                           */
/* empty css                                                                        */
/* empty css                                                               */
/* empty css                                                                */
/* empty css                                                                          */
/* empty css                                                                      */
/* empty css                                                                        */
/* empty css                                                                */
/* empty css                                                                        */
/* empty css                                                                     */
/* empty css                                                        */
/* empty css                                                                        */
/* empty css                                                                            */
/* empty css                                                                            */
/* empty css                                                                     */
/* empty css                                                                      */
/* empty css                                                                            */
import { p as hn, s as yn, b as bn } from "./baseMixins-HJffeBsS.js";
/* empty css                                                                       */
/* empty css                                                                          */
/* empty css                                                                  */
/* empty css                                                                       */
/* empty css                                                                   */
/* empty css                                                  */
import "./js.cookie-CA0diDCW.js";
import "./fileManager-BNE_Afa-.js";
import "pinia";
/* empty css                                                                        */
import "./CommentUploadFile.ce.vue_vue_type_script_lang-Bi4IeKWp.js";
import wn from "./Label.ce.js";
const H = {
  /**
   * Check if a date is valid
   * @param date - The date to validate
   * @param timezone - The timezone to use for validation
   * @returns boolean indicating if the date is valid
   */
  isValid: (e, t) => !e || typeof e == "string" ? !1 : K.fromMillis(e, { zone: t }).isValid,
  /**
   * Format a date using the specified format
   * @param date - The date to format
   * @param format - The format string
   * @param timezone - The timezone to use
   * @returns formatted date string or empty string if invalid
   */
  format: (e, t, n) => H.isValid(e, n) ? K.fromMillis(e, { zone: n }).toFormat(t) : "",
  /**
   * Standardize a date to start or end of day
   * @param date - The date to standardize
   * @param type - Whether to standardize to start or end of day
   * @param timezone - The timezone to use
   * @returns standardized date in milliseconds
   */
  standardize: (e, t, n) => {
    const a = typeof e == "number" ? e : e.getTime(), r = K.fromMillis(a, { zone: n });
    if (!r.isValid)
      throw new Error(`Invalid date: ${e}`);
    return t === "start" ? r.startOf("day").toMillis() : r.endOf("day").toMillis();
  },
  /**
   * Check if two dates are the same day
   * @param date1 - First date
   * @param date2 - Second date
   * @param timezone - The timezone to use for comparison
   * @returns boolean indicating if dates are the same day
   */
  isSameDay: (e, t, n) => {
    if (!e && !t) return !0;
    if (!e || !t) return !1;
    const a = K.fromMillis(e, { zone: n }), r = K.fromMillis(t, { zone: n });
    return !a.isValid && !r.isValid ? !0 : !a.isValid || !r.isValid ? !1 : a.hasSame(r, "day");
  },
  /**
   * Convert milliseconds to a structured date object
   * @param ms - Milliseconds timestamp
   * @param timezone - The timezone to use
   * @returns structured date object or null if invalid
   */
  toStructuredDate: (e, t) => {
    if (e == null || e === "")
      return null;
    const n = K.fromMillis(e, { zone: t });
    return n.isValid ? {
      date: n.day,
      months: n.month,
      years: n.year,
      dateString: n.toISO() || "",
      timezone: t,
      value: n.toJSDate(),
      toMillis: n.toMillis() ?? null
    } : null;
  },
  /**
   * Get initial date range value from start and end dates
   * @param start - Start date string
   * @param end - End date string
   * @param timezone - The timezone to use
   * @returns array with start and end dates in milliseconds
   */
  getInitialRangeValue: (e, t, n) => {
    const a = e ? new Date(e).getTime() : "", r = t ? new Date(t).getTime() : "";
    return a && r ? [a, r] : !a && !r ? ["", ""] : a && !r ? [a, ""] : !a && r ? ["", r] : ["", ""];
  }
}, St = (e, t) => {
  try {
    return e();
  } catch (n) {
    const a = n instanceof Error ? n : new Error(String(n));
    return console.error("Date operation failed:", a), t?.(a), null;
  }
}, F = {
  log: (e, ...t) => {
    process.env.NODE_ENV === "development" && console.log(`%c[DateRange] ${e}`, "color: white; font-weight: bold; font-size:24px", ...t);
  },
  warn: (e, ...t) => {
    process.env.NODE_ENV === "development" && console.warn(`%c[DateRange] ${e}`, "color: orange; font-weight: bold;", ...t);
  },
  error: (e, ...t) => {
    console.error(`%c[DateRange] ${e}`, "color: red; font-weight: bold;", ...t);
  }
}, Ot = {
  DEFAULT_TIMEZONE: K.local().zoneName,
  CLEANUP_DELAY: 100,
  WATCH_OPTIONS: {
    immediate: !0,
    deep: !1
  },
  SELECTION_WATCH_OPTIONS: {
    deep: !0,
    immediate: !0
  }
}, Dn = (e, t, n, a, r) => {
  try {
    const [i, s] = e, c = n === Ue.START && a, l = n === Ue.END && a, d = () => {
      const S = H.isValid(i, r), D = H.isValid(s, r);
      return S && D ? "filled" : !S && !D ? "both_empty" : !S && D ? "empty_start" : "empty_end";
    };
    if (!a)
      return "none";
    const u = {
      openStartOnStart: c && t === "start",
      openStartOnEnd: c && t === "end",
      openEndOnStart: l && t === "start",
      openEndOnEnd: l && t === "end"
    }, h = d();
    switch (!0) {
      case (h === "both_empty" && u.openStartOnStart):
        return "initiate";
      case (h === "both_empty" && u.openStartOnEnd):
        return "update";
      case (h === "both_empty" && u.openEndOnStart):
        return "initiate";
      case (h === "both_empty" && u.openEndOnEnd):
        return "strictUpdate";
      case (h === "empty_start" && u.openStartOnStart):
        return "initiate";
      case (h === "empty_start" && u.openStartOnEnd):
        return "update";
      case (h === "empty_start" && u.openEndOnStart):
        return "initiate";
      case (h === "empty_start" && u.openEndOnEnd):
        return "update";
      case (h === "empty_end" && u.openStartOnStart):
        return "initiate";
      case (h === "empty_end" && u.openStartOnEnd):
        return "update";
      case (h === "empty_end" && u.openEndOnStart):
        return "initiate";
      case (h === "empty_end" && u.openEndOnEnd):
        return "update";
      case (h === "filled" && u.openStartOnStart):
        return "strictUpdate";
      case (h === "filled" && u.openStartOnEnd):
        return "strictUpdate";
    }
    return "none";
  } catch (i) {
    return F.error("Error calculating date picker mode:", i), "update";
  }
}, Ji = (e, t) => {
  const n = W(), a = W(), r = W(["", ""]), i = W(["", ""]), s = W({ start: "", end: "" }), c = W(0), l = W(!1), d = W(!1), u = q(() => e.timezone || Ot.DEFAULT_TIMEZONE), h = Lt({
    focusingPosition: "none",
    openingCalendar: !1
  }), S = W({
    start: r.value[0],
    end: r.value[1]
  }), D = q(() => h.focusingPosition !== "none"), y = q(() => Dn(
    [S.value.start, S.value.end],
    h.focusingPosition,
    n.value,
    D.value,
    u.value
  )), w = q(() => ({
    start: H.toStructuredDate(r.value[0], u.value),
    end: H.toStructuredDate(r.value[1], u.value)
  })), T = () => {
    try {
      if (d.value) return;
      r.value = H.getInitialRangeValue(e.startDate, e.dueDate, u.value), s.value = {
        start: r.value[0],
        end: r.value[1]
      }, S.value = {
        start: r.value[0],
        end: r.value[1]
      }, p();
    } catch (m) {
      F.error("Error in setupDatePicker:", m);
    }
  }, p = () => {
    try {
      if (d.value) return;
      i.value = JSON.parse(JSON.stringify(r.value)), h.focusingPosition = "none", n.value = void 0, c.value++;
    } catch (m) {
      F.error("Error in cleanUp:", m);
    }
  }, O = () => {
    try {
      if (d.value) return;
      a.value?.closeMenu();
    } catch (m) {
      F.error("Failed to close calendar", m);
    } finally {
      p();
    }
  }, A = (m) => {
    try {
      if (d.value) return;
      (m() || y.value === "strictUpdate" || y.value === "update") && (o(), O());
    } catch (P) {
      F.error("Error in handleClickOutside:", P);
    }
  }, o = () => {
    try {
      if (d.value) return;
      const m = [
        S.value.start ? new Date(S.value.start) : null,
        S.value.end ? new Date(S.value.end) : null
      ];
      a.value?.selectDate(m), a.value?.updateInternalModelValue(m), _(), p(), st(() => {
        O();
      });
    } catch (m) {
      F.error("confirmSelect failed", m);
    }
  }, b = (m, P, L) => {
    try {
      if (d.value) return;
      m.stopPropagation(), h.focusingPosition === P ? O() : L();
    } catch (N) {
      F.error("Error in toggleCalendar:", N);
    }
  }, v = (m) => {
    n.value || (n.value = m), D.value || J(), h.focusingPosition = m;
  }, g = (m) => {
    try {
      m ? b(m, "start", () => v(Ue.START)) : v(Ue.START);
    } catch (P) {
      F.error("Error in selectStartField:", P);
    }
  }, E = (m) => {
    try {
      m ? b(m, "end", () => v(Ue.END)) : v(Ue.END);
    } catch (P) {
      F.error("Error in selectEndField:", P);
    }
  }, R = () => {
    try {
      if (d.value) return;
      r.value[0] = "", S.value.start = "", s.value.start = "", _();
    } catch (m) {
      F.error("Failed to clear start date", m);
    }
  }, I = () => {
    try {
      if (d.value) return;
      r.value[1] = "", S.value.end = "", s.value.end = "", _();
    } catch (m) {
      F.error("Failed to clear end date", m);
    }
  }, _ = () => {
    try {
      if (d.value) return;
      const [m, P] = [
        e.startDate ? new Date(e.startDate || "").getTime() : "",
        e.dueDate ? new Date(e.dueDate || "").getTime() : ""
      ], [L, N] = [
        H.isSameDay(r.value[0], m, u.value),
        H.isSameDay(r.value[1], P, u.value)
      ];
      if (!(L && N))
        t("update", w.value);
      else
        throw F.warn("No changes detected for sync", {
          selectedRange: r.value,
          oldStart: m,
          oldEnd: P,
          sameStart: L,
          sameEnd: N
        }), new Error("no change");
    } catch (m) {
      F.warn("Sync action failed", m);
    }
  }, B = (m) => {
    try {
      if (d.value) return;
      const P = St(
        () => H.standardize(m, "end", u.value),
        (L) => F.error("Failed to update strict end", L)
      );
      P && (r.value[1] = P, h.focusingPosition = "none", _(), O(), p());
    } catch (P) {
      F.error("updatestrictUpdate failed", P);
    }
  }, Y = (m) => {
    k.value = m;
  }, X = W(!0), j = (m) => {
    X.value = !0;
    try {
      const P = Number(m.getTime()), { end: L, start: N } = {
        end: () => H.standardize(P, "end", u.value),
        start: () => H.standardize(P, "start", u.value)
      };
      switch (!0) {
        case y.value === "initiate":
          if (!r.value[0] && !r.value[1] && h.focusingPosition === "start") {
            s.value.start = N(), r.value[0] = N(), h.focusingPosition = "end";
            return;
          } else if (r.value[1] && P > Number(r.value[1]) && h.focusingPosition === "start") {
            s.value.start = N(), s.value.end = L(), r.value[0] = N(), r.value[1] = L(), h.focusingPosition = "end";
            return;
          } else
            s.value.start = N(), r.value[0] = N(), h.focusingPosition = "end";
          break;
        case y.value === "strictUpdate":
          B(P);
          break;
        case y.value === "update":
          h.focusingPosition === "end" ? (P < Number(s.value.start) ? (s.value.start = N(), s.value.end = L(), r.value[0] = N(), r.value[1] = L()) : (r.value[1] = L() || "", s.value.end = L() || ""), h.focusingPosition = "end") : (r.value[0] = N() || "", s.value.start = N() || ""), h.focusingPosition = "end";
          break;
        case y.value === "none":
          console.error("No date selected");
          break;
      }
    } catch (P) {
      F.error("Error in selectStartDate:", P);
    }
  }, k = W(["", ""]), z = (m) => {
    X.value = !0;
    try {
      const P = m.getTime(), L = H.standardize(P, "end", u.value);
      y.value === "strictUpdate" ? B(P) : (r.value[1] = L, h.focusingPosition = "end");
    } catch (P) {
      F.error("Error in selectEndDate:", P);
    }
  }, J = () => {
    try {
      if (d.value) return;
      i.value = JSON.parse(JSON.stringify(r.value)), a.value?.openMenu();
    } catch (m) {
      F.error("Error in handleOpenMenu:", m);
    }
  }, G = () => {
    try {
      if (d.value) return;
      p();
    } catch (m) {
      F.error("Error in callbackClosed:", m);
    }
  }, oe = (m) => {
    try {
      if (d.value) return;
      E(), st(() => {
        a.value?.updateInternalModelValue([m, m]);
      });
    } catch (P) {
      F.error("Error in handleInvalidRange:", P);
    }
  }, Ee = () => {
    try {
      if (d.value) return;
      r.value = JSON.parse(JSON.stringify(i.value)), O();
    } catch (m) {
      F.error("Error in cancelSelect:", m);
    }
  }, ie = (m) => {
    try {
      if (d.value) return;
      const P = Array.isArray(m) && m.length === 1, L = Array.isArray(m) && m.length === 2, N = m instanceof Date, ee = m == null || Array.isArray(m) && m.length === 0, ve = (P || L) && St(() => H.standardize(m[0], "start", u.value)) || "", me = L && St(() => H.standardize(m[1], "end", u.value)) || "", _e = N && St(() => H.standardize(m, "start", u.value)) || "";
      switch (!0) {
        case (N && m instanceof Date):
          X.value && (r.value = [_e, ""]);
          break;
        case (P && h.focusingPosition === "start"):
          X.value && (r.value = [ve, ""]);
          break;
        case (P && h.focusingPosition === "end"):
          X.value && (r.value = ["", ve]);
          break;
        case L:
          X.value && (r.value = [ve, me]);
          break;
        case ee:
          r.value = ["", ""];
          break;
      }
    } catch (P) {
      F.error("Error in handleUpdateModelValue:", P);
    }
  }, Te = (m) => {
    try {
      if (d.value || !m || m.length <= 1) return;
      S.value = {
        start: m[0].getTime(),
        end: m[1].getTime()
      };
    } catch (P) {
      F.error("Error in handleInternalModelChange:", P);
    }
  }, fe = () => {
    try {
      if (d.value) return;
      A(() => H.isValid(S.value.start) && H.isValid(S.value.end));
    } catch (m) {
      F.error("Error in focusOut:", m);
    }
  }, ae = q(() => {
    try {
      if (d.value)
        return {
          partialRange: !0,
          hasStart: !1,
          hasEnd: !1,
          case: "initial",
          showLastInRange: !1
        };
      const m = h.focusingPosition, P = H.isValid(r.value[0], u.value), L = H.isValid(r.value[1], u.value), N = {
        partialRange: !0,
        hasStart: P,
        hasEnd: L,
        case: "initial",
        showLastInRange: h.focusingPosition === "end"
      };
      let ee = {};
      switch (!0) {
        case (m === "end" && !P && !L):
          ee = { fixedStart: !1, fixedEnd: !1, case: "no start" };
          break;
        case (m === "start" && P && L):
          ee = { fixedStart: !1, fixedEnd: !0, case: "block end" };
          break;
        case (m === "end" && L && P):
          ee = { fixedStart: !0, fixedEnd: !1, case: "block start" };
          break;
      }
      return { ...N, ...ee };
    } catch (m) {
      return F.error("Error in rangeConfig computed:", m), {
        partialRange: !0,
        hasStart: !1,
        hasEnd: !1,
        case: "initial",
        showLastInRange: !1
      };
    }
  }), pe = q(() => {
    try {
      const m = r.value[0] ? new Date(r.value[0]) : "", P = r.value[1] ? new Date(r.value[1]) : "", L = H.isValid(r.value[0], u.value), N = H.isValid(r.value[1], u.value), ee = H.isValid(S.value.start, u.value), ve = H.isValid(S.value.end, u.value);
      let me = [];
      return ve && ee ? me = [] : L && m && !N ? me = [K.fromJSDate(m, { zone: u.value }).startOf("day").toJSDate()] : !L && P && N && (me = [K.fromJSDate(P, { zone: u.value }).endOf("day").toJSDate()]), { dates: me };
    } catch (m) {
      return F.error("Error in highlightedDate computed:", m), { dates: [] };
    }
  }), Pe = q(() => ({
    teleport: e.teleport,
    disabled: e.disabled,
    format: e.shortFormat,
    timezone: u.value,
    enableTimePicker: !1,
    multiCalendars: e.multipleCalendar,
    modelAuto: !0,
    onClickOutside: A
  }));
  return we(
    [() => e.startDate, () => e.dueDate],
    () => {
      try {
        if (d.value) return;
        r.value = H.getInitialRangeValue(
          e.startDate,
          e.dueDate,
          u.value
        ), p();
      } catch (m) {
        F.error("Watch error", { error: m, start: e.startDate, due: e.dueDate });
      }
    },
    Ot.WATCH_OPTIONS
  ), we(
    () => e.timezone,
    () => {
      try {
        if (d.value) return;
        r.value = H.getInitialRangeValue(
          e.startDate,
          e.dueDate,
          e.timezone || Ot.DEFAULT_TIMEZONE
        ), a.value?.handleFlow();
      } catch (m) {
        F.error("Error in timezone watcher:", m);
      }
    }
  ), we(
    () => r.value,
    () => {
      try {
        if (d.value) return;
        S.value = {
          start: r.value[0],
          end: r.value[1]
        };
      } catch (m) {
        F.error("Error in selectedRange watcher:", m);
      }
    },
    Ot.SELECTION_WATCH_OPTIONS
  ), kr(() => {
    try {
      l.value = !0, T();
    } catch (m) {
      F.error("Error in onBeforeMount:", m);
    }
  }), Mr(() => {
    try {
      d.value = !0, p(), a.value = null, r.value = ["", ""], i.value = ["", ""], s.value = { start: "", end: "" }, S.value = { start: "", end: "" };
    } catch (m) {
      F.error("Error in onUnmounted:", m);
    }
  }), {
    // Refs
    dateRangePickerRef: a,
    selectedRange: r,
    renderKey: c,
    isDestroyed: d,
    // Reactive State
    states: h,
    previewingDate: S,
    selectingRange: s,
    // Computed Configurations
    vueDatepickerConfiguration: Pe,
    rangeConfig: ae,
    highlightedDate: pe,
    datePickerMode: y,
    // Event Handlers
    selectStartField: g,
    selectEndField: E,
    clearStartDate: R,
    clearEndDate: I,
    selectStartDate: j,
    selectEndDate: z,
    callbackClosed: G,
    handleInvalidRange: oe,
    cancelSelect: Ee,
    confirmSelect: o,
    handleUpdateModelValue: ie,
    handleInternalModelChange: Te,
    cleanUp: p,
    handleClickOutside: A,
    focusOut: fe,
    handleUpdateModelValueTz: Y,
    drValue: k
  };
}, He = ({ code: e, prefix: t, suffix: n }) => {
  const a = sessionStorage.getItem("ws.terminology"), r = a ? JSON.parse(a) : null;
  if (!r) return e;
  const i = r?.find((s) => s.code === e)?.name || "Scene";
  return `${t || ""} ${i} ${n || ""}`.trim();
}, Sn = { class: "rc__header flex flex-col items-center justify-center" }, On = { class: "rc__logo" }, En = { class: "rc__title text-center" }, Tn = { class: "rc__content" }, Cn = ["innerHTML"], xn = { class: "rc__hovered" }, Pn = { class: "rc__hovered__main" }, An = { class: "rc__content" }, kn = { class: "rc__actions flex items-center" }, Mn = /* @__PURE__ */ Ke({
  __name: "ReportCard",
  props: {
    name: {
      type: String,
      default: `Completed ${He({ code: "scene" })} Report`
    },
    subTitle: {
      type: String,
      default: `Download a report that includes the completed ${He({ code: "scene" })}.`
    },
    logo: {
      type: String,
      default: "ReportCompletedScenes"
    },
    isShowBackFlipTile: {
      type: Boolean,
      default: !1
    },
    minHeight: {
      type: String,
      default: "224px"
    },
    downloadBtnLabel: {
      type: String,
      default: "Download report"
    },
    description: {
      type: String,
      default: `Download a report that includes the completed ${He({ code: "scene" })}.`
    }
  },
  emits: ["update-state-flip", "clicked-download-btn"],
  setup(e, { emit: t }) {
    const n = e, a = t;
    function r() {
      a("clicked-download-btn");
    }
    function i() {
      a("update-state-flip", !n.isShowBackFlipTile);
    }
    function s() {
      n.isShowBackFlipTile || i();
    }
    const c = q(() => ({
      "--report-card__min-height": n.minHeight
    }));
    return (l, d) => (te(), ye("div", {
      class: "report-card rc",
      style: Ut(c.value)
    }, [
      Q("div", {
        class: "rc__body w-full",
        onClick: s
      }, [
        Q("div", {
          class: xe(["rc__wrapper", { hovering: e.isShowBackFlipTile }])
        }, [
          Q("div", Sn, [
            Q("div", On, [
              le(jt, {
                class: "rc__logo--img",
                name: e.logo,
                type: "visual"
              }, null, 8, ["name"])
            ]),
            Q("h3", En, lt(e.name), 1),
            le(fn, {
              class: "rc__header--flip",
              content: "Flip",
              delay: [300, 0]
            }, {
              default: rt(() => [
                le(Wt, {
                  class: "rc__header--btn-flip",
                  type: "secondary",
                  label: "",
                  "suffix-icon": e.isShowBackFlipTile ? "CustomFlipBack" : "CustomFlipFront",
                  onClick: Ht(i, ["stop"])
                }, null, 8, ["suffix-icon"])
              ]),
              _: 1
            })
          ]),
          At(Q("div", Tn, [
            Q("div", {
              class: "rc__sub-title",
              innerHTML: e.subTitle
            }, null, 8, Cn)
          ], 512), [
            [sr, !e.isShowBackFlipTile]
          ]),
          At(Q("div", xn, [
            Q("div", Pn, [
              nt(l.$slots, "content", { isShowBackFlipTile: e.isShowBackFlipTile }, () => [
                Q("div", An, lt(n.description), 1)
              ], !0)
            ]),
            nt(l.$slots, "actions", {}, () => [
              Q("div", kn, [
                le(Wt, {
                  class: "rc__actions--download-btn w-full",
                  type: "primary",
                  onClick: Ht(r, ["stop"]),
                  label: n.downloadBtnLabel
                }, null, 8, ["label"])
              ])
            ], !0)
          ], 512), [
            [sr, e.isShowBackFlipTile]
          ])
        ], 2)
      ])
    ], 4));
  }
}), Rn = /* @__PURE__ */ Gt(Mn, [["__scopeId", "data-v-a4789577"]]), Ln = (e, t, n) => {
  const a = {
    truncate: "End date cleared because it was before start. Please pick an end date.",
    swap: "Dates auto-swapped because start was after end.",
    ...e.messages
  }, r = Lt({
    startDate: null,
    endDate: null,
    timezone: e.timezone || "UTC",
    format: e.format || "",
    isSelectingStart: !1,
    isSelectingEnd: !1,
    rangeFeedback: {
      status: "idle",
      action: null,
      message: ""
    },
    // Cache of last confirmed values
    cacheStartDate: null,
    cacheEndDate: null,
    isDirty: !1
  });
  kr(() => {
    e.modelValue?.length === 2 && (r.startDate = e.modelValue[0], r.endDate = e.modelValue[1]), r.cacheStartDate = r.startDate, r.cacheEndDate = r.endDate, r.isSelectingStart = !1, r.isSelectingEnd = !1, e.timezone && (r.timezone = e.timezone);
  });
  const i = () => {
    t("tracing", JSON.parse(JSON.stringify(n.value))), t("update:start", r.startDate), t("update:end", r.endDate);
    const b = {
      start: H.toStructuredDate(r.startDate?.getTime() || "", r.timezone),
      end: H.toStructuredDate(r.endDate?.getTime() || "", r.timezone)
    };
    (r.startDate || r.endDate) && (t("legacyUpdate", b), t("update", [r.startDate, r.endDate])), r.isDirty = !(r.startDate?.getTime?.() === r.cacheStartDate?.getTime?.() && r.endDate?.getTime?.() === r.cacheEndDate?.getTime?.());
  }, s = (b, v) => {
    const g = K.fromObject({ year: b.year, month: b.month, day: b.day }, { zone: r.timezone });
    return (v === "start" ? g.startOf("day") : g.endOf("day")).toJSDate();
  }, c = () => {
    r.rangeFeedback.status = "idle", r.rangeFeedback.action = null, r.rangeFeedback.message = "";
  }, l = (b) => {
    e.enableRangeFeedback && (r.rangeFeedback.status = "corrected", r.rangeFeedback.action = b, r.rangeFeedback.message = b === "swap" ? a.swap : a.truncate);
  }, d = (b) => {
    if (!(!r.startDate || !r.endDate)) {
      if (r.startDate.getTime() <= r.endDate.getTime()) {
        e.enableRangeFeedback && c();
        return;
      }
      if (b === "select-start") {
        const v = { start: r.startDate, end: r.endDate };
        r.endDate = null, t("range:invalid", v), t("range:corrected", { start: r.startDate, end: r.endDate, action: "truncate" }), r.isSelectingEnd = !0, l("truncate"), e.enableRangeFeedback && !r.rangeFeedback.message && (r.rangeFeedback.message = a.truncate);
      } else {
        const v = { start: r.startDate, end: r.endDate }, g = r.startDate;
        r.startDate = r.endDate, r.endDate = g, t("range:invalid", v), t("range:corrected", { start: r.startDate, end: r.endDate, action: "swap" }), l("swap");
      }
    }
  }, u = (b, v = !0) => {
    e.disabled || e.readonly || (r.startDate = s(b, "start"), v ? (r.isSelectingStart = !1, r.isSelectingEnd = !0) : (r.isSelectingStart = !0, r.isSelectingEnd = !1), d("select-start"));
  }, h = (b) => {
    e.disabled || e.readonly || (r.endDate = s(b, "end"), d("select-end"));
  }, S = () => {
    e.disabled || e.readonly || (r.startDate = null, t("clearStart"), c(), i());
  }, D = () => {
    e.disabled || e.readonly || (r.endDate = null, t("clearDue"), c(), i());
  }, y = () => {
    e.disabled || e.readonly || r.isDirty || (r.cacheStartDate = r.startDate, r.cacheEndDate = r.endDate);
  }, w = () => {
    e.disabled || e.readonly || (r.cacheStartDate = r.startDate, r.cacheEndDate = r.endDate, r.isDirty = !1, i());
  }, T = () => {
    e.disabled || e.readonly || (r.startDate = r.cacheStartDate, r.endDate = r.cacheEndDate, c(), i(), r.isDirty = !1);
  }, p = q(() => r.startDate ? K.fromJSDate(r.startDate, { zone: r.timezone }).toFormat(r.format) : e.startPlaceholder), O = q(() => r.endDate ? K.fromJSDate(r.endDate, { zone: r.timezone }).toFormat(r.format) : e.duePlaceholder), A = q(() => !r.startDate && !e.disabled ? e.startTooltip : !r.startDate && (e.disabled || e.readonly) ? e.startPlaceholder : r.startDate ? K.fromJSDate(r.startDate, { zone: r.timezone }).toFormat("LLL dd, yyyy | HH:mm:ss") : e.startTooltip), o = q(() => !r.endDate && !e.disabled ? e.dueTooltip : !r.endDate && (e.disabled || e.readonly) ? e.startPlaceholder : r.endDate ? K.fromJSDate(r.endDate, { zone: r.timezone }).toFormat("LLL dd, yyyy | HH:mm:ss") : e.dueTooltip);
  return {
    states: r,
    displayStartDate: p,
    displayEndDate: O,
    tooltipStartDate: A,
    tooltipEndDate: o,
    selectEndDate: h,
    selectStartDate: u,
    clearDue: D,
    clearStart: S,
    beginInteraction: y,
    confirmSelection: w,
    cancelSelection: T
  };
}, Bn = ["aria-disabled", "aria-readonly"], Vn = ["disabled", "aria-expanded", "aria-label"], In = {
  key: 1,
  class: "adpb-icon",
  "aria-hidden": "true"
}, $n = ["aria-readonly"], _n = {
  key: 0,
  class: "adpb-icon",
  "aria-hidden": "true"
}, Fn = /* @__PURE__ */ Ke({
  __name: "ArboDatePickerButton",
  props: {
    modelValue: {},
    format: { default: "LLL dd" },
    placeholder: { default: "Select date" },
    timezone: { default: "UTC" },
    active: { type: Boolean, default: !1 },
    tooltip: { default: "" },
    type: {},
    actual: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    showIcon: { type: Boolean, default: !0 },
    size: { default: "medium" }
  },
  emits: ["clear", "open"],
  setup(e, { emit: t }) {
    const n = gn, a = e, r = q(() => a.disabled), i = q(() => a.readonly), s = t, c = q(() => {
      if (!a.modelValue) return "empty";
      const w = K.fromJSDate(a.modelValue, { zone: a.timezone }), T = K.now().setZone(a.timezone).startOf("day"), O = w.startOf("day").toISODate();
      return O === T.toISODate() ? "today" : O === T.plus({ days: 1 }).toISODate() ? "tomorrow" : O === T.minus({ days: 1 }).toISODate() ? "yesterday" : w < T ? "past" : w > T ? "future" : "actual";
    }), l = q(() => a.modelValue ? c.value === "today" ? "Today" : c.value === "tomorrow" ? "Tomorrow" : c.value === "yesterday" ? "Yesterday" : K.fromJSDate(a.modelValue, { zone: a.timezone }).toFormat(a.format) : a.placeholder), d = q(() => !!a.showIcon), u = q(() => !!a.modelValue && !a.disabled && !a.readonly), h = q(() => {
      let w = 0;
      return u.value && w++, d.value && w++, w;
    }), S = q(() => ({ "--adp-icon-count": h.value }));
    function D() {
      a.disabled || a.readonly || s("clear");
    }
    function y() {
      a.disabled || a.readonly || s("open");
    }
    return (w, T) => !r.value && !i.value ? (te(), ye("div", {
      key: 0,
      class: xe(["arbo-date-picker-button", {
        "has-value": !!e.modelValue,
        active: e.active,
        disabled: r.value,
        readonly: i.value,
        "has-clear": u.value,
        "has-icon": d.value,
        small: a.size === "small"
      }]),
      style: Ut(S.value),
      "aria-disabled": r.value ? "true" : "false",
      "aria-readonly": i.value ? "true" : "false",
      role: "group",
      onClick: y
    }, [
      At((te(), ye("button", {
        class: xe(["adpb-main", { "is-empty": !e.modelValue }]),
        type: "button",
        disabled: r.value || i.value,
        "aria-haspopup": "dialog",
        "aria-expanded": e.active ? "true" : "false",
        "aria-label": `${e.type === "start" ? "Start date" : "End date"} picker`,
        onFocus: y
      }, [
        Q("span", {
          class: xe(["adpb-label", [`${e.type}-${c.value}`, e.actual ? "actual" : ""]])
        }, lt(l.value), 3)
      ], 42, Vn)), [
        [$(n), { content: a.tooltip || l.value }]
      ]),
      u.value ? (te(), kt($(Wt), {
        key: 0,
        size: "small",
        label: "",
        "prefix-icon": "Xmark",
        type: "primary",
        disabled: a.disabled,
        "prefix-tooltip": "Clear",
        class: "adpb-clear",
        "aria-haspopup": "dialog",
        "aria-expanded": e.active ? "true" : "false",
        "aria-label": `${e.type === "start" ? "Start date" : "End date"} picker`,
        onClick: Ht(D, ["stop"])
      }, null, 8, ["disabled", "aria-expanded", "aria-label"])) : at("", !0),
      d.value ? (te(), ye("span", In, [
        le($(jt), { name: "Calendar" })
      ])) : at("", !0)
    ], 14, Bn)) : (te(), ye("div", {
      key: 1,
      class: xe(["arbo-date-picker-button view-only", {
        "has-value": !!e.modelValue,
        active: e.active,
        disabled: r.value,
        readonly: i.value,
        "has-clear": !1,
        "has-icon": d.value,
        small: a.size === "small"
      }]),
      style: Ut(S.value),
      "aria-disabled": "true",
      "aria-readonly": i.value ? "true" : "false",
      role: "group"
    }, [
      At((te(), ye("button", {
        class: xe(["adpb-main", { "is-empty": !e.modelValue }]),
        type: "button",
        disabled: ""
      }, [
        Q("span", {
          class: xe(["adpb-label", [`${e.type}-${c.value}`, e.actual ? "actual" : ""]])
        }, lt(l.value), 3)
      ], 2)), [
        [$(n), { content: a.tooltip || l.value }]
      ]),
      d.value ? (te(), ye("span", _n, [
        le($(jt), { name: "Calendar" })
      ])) : at("", !0)
    ], 14, $n));
  }
}), dr = /* @__PURE__ */ Gt(Fn, [["__scopeId", "data-v-8c0ff777"]]);
var re = "top", ce = "bottom", de = "right", ne = "left", Zt = "auto", ft = [re, ce, de, ne], je = "start", ut = "end", zn = "clippingParents", Rr = "viewport", tt = "popper", Nn = "reference", fr = /* @__PURE__ */ ft.reduce(function(e, t) {
  return e.concat([t + "-" + je, t + "-" + ut]);
}, []), Lr = /* @__PURE__ */ [].concat(ft, [Zt]).reduce(function(e, t) {
  return e.concat([t, t + "-" + je, t + "-" + ut]);
}, []), Un = "beforeRead", Hn = "read", jn = "afterRead", Wn = "beforeMain", Yn = "main", Xn = "afterMain", qn = "beforeWrite", Jn = "write", Kn = "afterWrite", Gn = [Un, Hn, jn, Wn, Yn, Xn, qn, Jn, Kn];
function Se(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function he(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function We(e) {
  var t = he(e).Element;
  return e instanceof t || e instanceof Element;
}
function ue(e) {
  var t = he(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Br(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = he(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Zn(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var a = t.styles[n] || {}, r = t.attributes[n] || {}, i = t.elements[n];
    !ue(i) || !Se(i) || (Object.assign(i.style, a), Object.keys(r).forEach(function(s) {
      var c = r[s];
      c === !1 ? i.removeAttribute(s) : i.setAttribute(s, c === !0 ? "" : c);
    }));
  });
}
function Qn(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var r = t.elements[a], i = t.attributes[a] || {}, s = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : n[a]), c = s.reduce(function(l, d) {
        return l[d] = "", l;
      }, {});
      !ue(r) || !Se(r) || (Object.assign(r.style, c), Object.keys(i).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
var Vr = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Zn,
  effect: Qn,
  requires: ["computeStyles"]
};
function De(e) {
  return e.split("-")[0];
}
var Ie = Math.max, Mt = Math.min, Ye = Math.round;
function Xe(e, t) {
  t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), a = 1, r = 1;
  if (ue(e) && t) {
    var i = e.offsetHeight, s = e.offsetWidth;
    s > 0 && (a = Ye(n.width) / s || 1), i > 0 && (r = Ye(n.height) / i || 1);
  }
  return {
    width: n.width / a,
    height: n.height / r,
    top: n.top / r,
    right: n.right / a,
    bottom: n.bottom / r,
    left: n.left / a,
    x: n.left / a,
    y: n.top / r
  };
}
function Qt(e) {
  var t = Xe(e), n = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: a
  };
}
function Ir(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Br(n)) {
    var a = t;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function Oe(e) {
  return he(e).getComputedStyle(e);
}
function ea(e) {
  return ["table", "td", "th"].indexOf(Se(e)) >= 0;
}
function Me(e) {
  return ((We(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Bt(e) {
  return Se(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Br(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Me(e)
  );
}
function pr(e) {
  return !ue(e) || // https://github.com/popperjs/popper-core/issues/837
  Oe(e).position === "fixed" ? null : e.offsetParent;
}
function ta(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
  if (n && ue(e)) {
    var a = Oe(e);
    if (a.position === "fixed")
      return null;
  }
  for (var r = Bt(e); ue(r) && ["html", "body"].indexOf(Se(r)) < 0; ) {
    var i = Oe(r);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function pt(e) {
  for (var t = he(e), n = pr(e); n && ea(n) && Oe(n).position === "static"; )
    n = pr(n);
  return n && (Se(n) === "html" || Se(n) === "body" && Oe(n).position === "static") ? t : n || ta(e) || t;
}
function er(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function ot(e, t, n) {
  return Ie(e, Mt(t, n));
}
function ra(e, t, n) {
  var a = ot(e, t, n);
  return a > n ? n : a;
}
function $r() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function _r(e) {
  return Object.assign({}, $r(), e);
}
function Fr(e, t) {
  return t.reduce(function(n, a) {
    return n[a] = e, n;
  }, {});
}
var na = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, _r(typeof t != "number" ? t : Fr(t, ft));
};
function aa(e) {
  var t, n = e.state, a = e.name, r = e.options, i = n.elements.arrow, s = n.modifiersData.popperOffsets, c = De(n.placement), l = er(c), d = [ne, de].indexOf(c) >= 0, u = d ? "height" : "width";
  if (!(!i || !s)) {
    var h = na(r.padding, n), S = Qt(i), D = l === "y" ? re : ne, y = l === "y" ? ce : de, w = n.rects.reference[u] + n.rects.reference[l] - s[l] - n.rects.popper[u], T = s[l] - n.rects.reference[l], p = pt(i), O = p ? l === "y" ? p.clientHeight || 0 : p.clientWidth || 0 : 0, A = w / 2 - T / 2, o = h[D], b = O - S[u] - h[y], v = O / 2 - S[u] / 2 + A, g = ot(o, v, b), E = l;
    n.modifiersData[a] = (t = {}, t[E] = g, t.centerOffset = g - v, t);
  }
}
function oa(e) {
  var t = e.state, n = e.options, a = n.element, r = a === void 0 ? "[data-popper-arrow]" : a;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || Ir(t.elements.popper, r) && (t.elements.arrow = r));
}
var ia = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: aa,
  effect: oa,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function qe(e) {
  return e.split("-")[1];
}
var sa = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function la(e) {
  var t = e.x, n = e.y, a = window, r = a.devicePixelRatio || 1;
  return {
    x: Ye(t * r) / r || 0,
    y: Ye(n * r) / r || 0
  };
}
function vr(e) {
  var t, n = e.popper, a = e.popperRect, r = e.placement, i = e.variation, s = e.offsets, c = e.position, l = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, h = e.isFixed, S = u === !0 ? la(s) : typeof u == "function" ? u(s) : s, D = S.x, y = D === void 0 ? 0 : D, w = S.y, T = w === void 0 ? 0 : w, p = s.hasOwnProperty("x"), O = s.hasOwnProperty("y"), A = ne, o = re, b = window;
  if (d) {
    var v = pt(n), g = "clientHeight", E = "clientWidth";
    if (v === he(n) && (v = Me(n), Oe(v).position !== "static" && c === "absolute" && (g = "scrollHeight", E = "scrollWidth")), v = v, r === re || (r === ne || r === de) && i === ut) {
      o = ce;
      var R = h && b.visualViewport ? b.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        v[g]
      );
      T -= R - a.height, T *= l ? 1 : -1;
    }
    if (r === ne || (r === re || r === ce) && i === ut) {
      A = de;
      var I = h && b.visualViewport ? b.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        v[E]
      );
      y -= I - a.width, y *= l ? 1 : -1;
    }
  }
  var _ = Object.assign({
    position: c
  }, d && sa);
  if (l) {
    var B;
    return Object.assign({}, _, (B = {}, B[o] = O ? "0" : "", B[A] = p ? "0" : "", B.transform = (b.devicePixelRatio || 1) <= 1 ? "translate(" + y + "px, " + T + "px)" : "translate3d(" + y + "px, " + T + "px, 0)", B));
  }
  return Object.assign({}, _, (t = {}, t[o] = O ? T + "px" : "", t[A] = p ? y + "px" : "", t.transform = "", t));
}
function ua(e) {
  var t = e.state, n = e.options, a = n.gpuAcceleration, r = a === void 0 ? !0 : a, i = n.adaptive, s = i === void 0 ? !0 : i, c = n.roundOffsets, l = c === void 0 ? !0 : c, d = {
    placement: De(t.placement),
    variation: qe(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, vr(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, vr(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
var ca = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: ua,
  data: {}
}, Et = {
  passive: !0
};
function da(e) {
  var t = e.state, n = e.instance, a = e.options, r = a.scroll, i = r === void 0 ? !0 : r, s = a.resize, c = s === void 0 ? !0 : s, l = he(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && d.forEach(function(u) {
    u.addEventListener("scroll", n.update, Et);
  }), c && l.addEventListener("resize", n.update, Et), function() {
    i && d.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Et);
    }), c && l.removeEventListener("resize", n.update, Et);
  };
}
var fa = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: da,
  data: {}
}, pa = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Pt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return pa[t];
  });
}
var va = {
  start: "end",
  end: "start"
};
function mr(e) {
  return e.replace(/start|end/g, function(t) {
    return va[t];
  });
}
function tr(e) {
  var t = he(e), n = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: a
  };
}
function rr(e) {
  return Xe(Me(e)).left + tr(e).scrollLeft;
}
function ma(e) {
  var t = he(e), n = Me(e), a = t.visualViewport, r = n.clientWidth, i = n.clientHeight, s = 0, c = 0;
  return a && (r = a.width, i = a.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (s = a.offsetLeft, c = a.offsetTop)), {
    width: r,
    height: i,
    x: s + rr(e),
    y: c
  };
}
function ga(e) {
  var t, n = Me(e), a = tr(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, i = Ie(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), s = Ie(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), c = -a.scrollLeft + rr(e), l = -a.scrollTop;
  return Oe(r || n).direction === "rtl" && (c += Ie(n.clientWidth, r ? r.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function nr(e) {
  var t = Oe(e), n = t.overflow, a = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + a);
}
function zr(e) {
  return ["html", "body", "#document"].indexOf(Se(e)) >= 0 ? e.ownerDocument.body : ue(e) && nr(e) ? e : zr(Bt(e));
}
function it(e, t) {
  var n;
  t === void 0 && (t = []);
  var a = zr(e), r = a === ((n = e.ownerDocument) == null ? void 0 : n.body), i = he(a), s = r ? [i].concat(i.visualViewport || [], nr(a) ? a : []) : a, c = t.concat(s);
  return r ? c : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    c.concat(it(Bt(s)))
  );
}
function Yt(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function ha(e) {
  var t = Xe(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function gr(e, t) {
  return t === Rr ? Yt(ma(e)) : We(t) ? ha(t) : Yt(ga(Me(e)));
}
function ya(e) {
  var t = it(Bt(e)), n = ["absolute", "fixed"].indexOf(Oe(e).position) >= 0, a = n && ue(e) ? pt(e) : e;
  return We(a) ? t.filter(function(r) {
    return We(r) && Ir(r, a) && Se(r) !== "body" && (n ? Oe(r).position !== "static" : !0);
  }) : [];
}
function ba(e, t, n) {
  var a = t === "clippingParents" ? ya(e) : [].concat(t), r = [].concat(a, [n]), i = r[0], s = r.reduce(function(c, l) {
    var d = gr(e, l);
    return c.top = Ie(d.top, c.top), c.right = Mt(d.right, c.right), c.bottom = Mt(d.bottom, c.bottom), c.left = Ie(d.left, c.left), c;
  }, gr(e, i));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Nr(e) {
  var t = e.reference, n = e.element, a = e.placement, r = a ? De(a) : null, i = a ? qe(a) : null, s = t.x + t.width / 2 - n.width / 2, c = t.y + t.height / 2 - n.height / 2, l;
  switch (r) {
    case re:
      l = {
        x: s,
        y: t.y - n.height
      };
      break;
    case ce:
      l = {
        x: s,
        y: t.y + t.height
      };
      break;
    case de:
      l = {
        x: t.x + t.width,
        y: c
      };
      break;
    case ne:
      l = {
        x: t.x - n.width,
        y: c
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var d = r ? er(r) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (i) {
      case je:
        l[d] = l[d] - (t[u] / 2 - n[u] / 2);
        break;
      case ut:
        l[d] = l[d] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function ct(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, r = a === void 0 ? e.placement : a, i = n.boundary, s = i === void 0 ? zn : i, c = n.rootBoundary, l = c === void 0 ? Rr : c, d = n.elementContext, u = d === void 0 ? tt : d, h = n.altBoundary, S = h === void 0 ? !1 : h, D = n.padding, y = D === void 0 ? 0 : D, w = _r(typeof y != "number" ? y : Fr(y, ft)), T = u === tt ? Nn : tt, p = e.rects.popper, O = e.elements[S ? T : u], A = ba(We(O) ? O : O.contextElement || Me(e.elements.popper), s, l), o = Xe(e.elements.reference), b = Nr({
    reference: o,
    element: p,
    placement: r
  }), v = Yt(Object.assign({}, p, b)), g = u === tt ? v : o, E = {
    top: A.top - g.top + w.top,
    bottom: g.bottom - A.bottom + w.bottom,
    left: A.left - g.left + w.left,
    right: g.right - A.right + w.right
  }, R = e.modifiersData.offset;
  if (u === tt && R) {
    var I = R[r];
    Object.keys(E).forEach(function(_) {
      var B = [de, ce].indexOf(_) >= 0 ? 1 : -1, Y = [re, ce].indexOf(_) >= 0 ? "y" : "x";
      E[_] += I[Y] * B;
    });
  }
  return E;
}
function wa(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, r = n.boundary, i = n.rootBoundary, s = n.padding, c = n.flipVariations, l = n.allowedAutoPlacements, d = l === void 0 ? Lr : l, u = qe(a), h = u ? c ? fr : fr.filter(function(y) {
    return qe(y) === u;
  }) : ft, S = h.filter(function(y) {
    return d.indexOf(y) >= 0;
  });
  S.length === 0 && (S = h);
  var D = S.reduce(function(y, w) {
    return y[w] = ct(e, {
      placement: w,
      boundary: r,
      rootBoundary: i,
      padding: s
    })[De(w)], y;
  }, {});
  return Object.keys(D).sort(function(y, w) {
    return D[y] - D[w];
  });
}
function Da(e) {
  if (De(e) === Zt)
    return [];
  var t = Pt(e);
  return [mr(e), t, mr(t)];
}
function Sa(e) {
  var t = e.state, n = e.options, a = e.name;
  if (!t.modifiersData[a]._skip) {
    for (var r = n.mainAxis, i = r === void 0 ? !0 : r, s = n.altAxis, c = s === void 0 ? !0 : s, l = n.fallbackPlacements, d = n.padding, u = n.boundary, h = n.rootBoundary, S = n.altBoundary, D = n.flipVariations, y = D === void 0 ? !0 : D, w = n.allowedAutoPlacements, T = t.options.placement, p = De(T), O = p === T, A = l || (O || !y ? [Pt(T)] : Da(T)), o = [T].concat(A).reduce(function(fe, ae) {
      return fe.concat(De(ae) === Zt ? wa(t, {
        placement: ae,
        boundary: u,
        rootBoundary: h,
        padding: d,
        flipVariations: y,
        allowedAutoPlacements: w
      }) : ae);
    }, []), b = t.rects.reference, v = t.rects.popper, g = /* @__PURE__ */ new Map(), E = !0, R = o[0], I = 0; I < o.length; I++) {
      var _ = o[I], B = De(_), Y = qe(_) === je, X = [re, ce].indexOf(B) >= 0, j = X ? "width" : "height", k = ct(t, {
        placement: _,
        boundary: u,
        rootBoundary: h,
        altBoundary: S,
        padding: d
      }), z = X ? Y ? de : ne : Y ? ce : re;
      b[j] > v[j] && (z = Pt(z));
      var J = Pt(z), G = [];
      if (i && G.push(k[B] <= 0), c && G.push(k[z] <= 0, k[J] <= 0), G.every(function(fe) {
        return fe;
      })) {
        R = _, E = !1;
        break;
      }
      g.set(_, G);
    }
    if (E)
      for (var oe = y ? 3 : 1, Ee = function(ae) {
        var pe = o.find(function(Pe) {
          var m = g.get(Pe);
          if (m)
            return m.slice(0, ae).every(function(P) {
              return P;
            });
        });
        if (pe)
          return R = pe, "break";
      }, ie = oe; ie > 0; ie--) {
        var Te = Ee(ie);
        if (Te === "break") break;
      }
    t.placement !== R && (t.modifiersData[a]._skip = !0, t.placement = R, t.reset = !0);
  }
}
var Oa = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Sa,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function hr(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function yr(e) {
  return [re, de, ce, ne].some(function(t) {
    return e[t] >= 0;
  });
}
function Ea(e) {
  var t = e.state, n = e.name, a = t.rects.reference, r = t.rects.popper, i = t.modifiersData.preventOverflow, s = ct(t, {
    elementContext: "reference"
  }), c = ct(t, {
    altBoundary: !0
  }), l = hr(s, a), d = hr(c, r, i), u = yr(l), h = yr(d);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: h
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": h
  });
}
var Ta = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Ea
};
function Ca(e, t, n) {
  var a = De(e), r = [ne, re].indexOf(a) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = i[0], c = i[1];
  return s = s || 0, c = (c || 0) * r, [ne, de].indexOf(a) >= 0 ? {
    x: c,
    y: s
  } : {
    x: s,
    y: c
  };
}
function xa(e) {
  var t = e.state, n = e.options, a = e.name, r = n.offset, i = r === void 0 ? [0, 0] : r, s = Lr.reduce(function(u, h) {
    return u[h] = Ca(h, t.rects, i), u;
  }, {}), c = s[t.placement], l = c.x, d = c.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += d), t.modifiersData[a] = s;
}
var Pa = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: xa
};
function Aa(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Nr({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
var ka = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Aa,
  data: {}
};
function Ma(e) {
  return e === "x" ? "y" : "x";
}
function Ra(e) {
  var t = e.state, n = e.options, a = e.name, r = n.mainAxis, i = r === void 0 ? !0 : r, s = n.altAxis, c = s === void 0 ? !1 : s, l = n.boundary, d = n.rootBoundary, u = n.altBoundary, h = n.padding, S = n.tether, D = S === void 0 ? !0 : S, y = n.tetherOffset, w = y === void 0 ? 0 : y, T = ct(t, {
    boundary: l,
    rootBoundary: d,
    padding: h,
    altBoundary: u
  }), p = De(t.placement), O = qe(t.placement), A = !O, o = er(p), b = Ma(o), v = t.modifiersData.popperOffsets, g = t.rects.reference, E = t.rects.popper, R = typeof w == "function" ? w(Object.assign({}, t.rects, {
    placement: t.placement
  })) : w, I = typeof R == "number" ? {
    mainAxis: R,
    altAxis: R
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, R), _ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, B = {
    x: 0,
    y: 0
  };
  if (v) {
    if (i) {
      var Y, X = o === "y" ? re : ne, j = o === "y" ? ce : de, k = o === "y" ? "height" : "width", z = v[o], J = z + T[X], G = z - T[j], oe = D ? -E[k] / 2 : 0, Ee = O === je ? g[k] : E[k], ie = O === je ? -E[k] : -g[k], Te = t.elements.arrow, fe = D && Te ? Qt(Te) : {
        width: 0,
        height: 0
      }, ae = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : $r(), pe = ae[X], Pe = ae[j], m = ot(0, g[k], fe[k]), P = A ? g[k] / 2 - oe - m - pe - I.mainAxis : Ee - m - pe - I.mainAxis, L = A ? -g[k] / 2 + oe + m + Pe + I.mainAxis : ie + m + Pe + I.mainAxis, N = t.elements.arrow && pt(t.elements.arrow), ee = N ? o === "y" ? N.clientTop || 0 : N.clientLeft || 0 : 0, ve = (Y = _?.[o]) != null ? Y : 0, me = z + P - ve - ee, _e = z + L - ve, Ge = ot(D ? Mt(J, me) : J, z, D ? Ie(G, _e) : G);
      v[o] = Ge, B[o] = Ge - z;
    }
    if (c) {
      var Ze, vt = o === "x" ? re : ne, mt = o === "x" ? ce : de, Ce = v[b], Ae = b === "y" ? "height" : "width", Qe = Ce + T[vt], Re = Ce - T[mt], et = [re, ne].indexOf(p) !== -1, gt = (Ze = _?.[b]) != null ? Ze : 0, ht = et ? Qe : Ce - g[Ae] - E[Ae] - gt + I.altAxis, yt = et ? Ce + g[Ae] + E[Ae] - gt - I.altAxis : Re, bt = D && et ? ra(ht, Ce, yt) : ot(D ? ht : Qe, Ce, D ? yt : Re);
      v[b] = bt, B[b] = bt - Ce;
    }
    t.modifiersData[a] = B;
  }
}
var La = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Ra,
  requiresIfExists: ["offset"]
};
function Ba(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Va(e) {
  return e === he(e) || !ue(e) ? tr(e) : Ba(e);
}
function Ia(e) {
  var t = e.getBoundingClientRect(), n = Ye(t.width) / e.offsetWidth || 1, a = Ye(t.height) / e.offsetHeight || 1;
  return n !== 1 || a !== 1;
}
function $a(e, t, n) {
  n === void 0 && (n = !1);
  var a = ue(t), r = ue(t) && Ia(t), i = Me(t), s = Xe(e, r), c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (a || !a && !n) && ((Se(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  nr(i)) && (c = Va(t)), ue(t) ? (l = Xe(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = rr(i))), {
    x: s.left + c.scrollLeft - l.x,
    y: s.top + c.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function _a(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function r(i) {
    n.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(c) {
      if (!n.has(c)) {
        var l = t.get(c);
        l && r(l);
      }
    }), a.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || r(i);
  }), a;
}
function Fa(e) {
  var t = _a(e);
  return Gn.reduce(function(n, a) {
    return n.concat(t.filter(function(r) {
      return r.phase === a;
    }));
  }, []);
}
function za(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Na(e) {
  var t = e.reduce(function(n, a) {
    var r = n[a.name];
    return n[a.name] = r ? Object.assign({}, r, a, {
      options: Object.assign({}, r.options, a.options),
      data: Object.assign({}, r.data, a.data)
    }) : a, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var br = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function wr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function Ua(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, a = n === void 0 ? [] : n, r = t.defaultOptions, i = r === void 0 ? br : r;
  return function(c, l, d) {
    d === void 0 && (d = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, br, i),
      modifiersData: {},
      elements: {
        reference: c,
        popper: l
      },
      attributes: {},
      styles: {}
    }, h = [], S = !1, D = {
      state: u,
      setOptions: function(p) {
        var O = typeof p == "function" ? p(u.options) : p;
        w(), u.options = Object.assign({}, i, u.options, O), u.scrollParents = {
          reference: We(c) ? it(c) : c.contextElement ? it(c.contextElement) : [],
          popper: it(l)
        };
        var A = Fa(Na([].concat(a, u.options.modifiers)));
        return u.orderedModifiers = A.filter(function(o) {
          return o.enabled;
        }), y(), D.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!S) {
          var p = u.elements, O = p.reference, A = p.popper;
          if (wr(O, A)) {
            u.rects = {
              reference: $a(O, pt(A), u.options.strategy === "fixed"),
              popper: Qt(A)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(I) {
              return u.modifiersData[I.name] = Object.assign({}, I.data);
            });
            for (var o = 0; o < u.orderedModifiers.length; o++) {
              if (u.reset === !0) {
                u.reset = !1, o = -1;
                continue;
              }
              var b = u.orderedModifiers[o], v = b.fn, g = b.options, E = g === void 0 ? {} : g, R = b.name;
              typeof v == "function" && (u = v({
                state: u,
                options: E,
                name: R,
                instance: D
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: za(function() {
        return new Promise(function(T) {
          D.forceUpdate(), T(u);
        });
      }),
      destroy: function() {
        w(), S = !0;
      }
    };
    if (!wr(c, l))
      return D;
    D.setOptions(d).then(function(T) {
      !S && d.onFirstUpdate && d.onFirstUpdate(T);
    });
    function y() {
      u.orderedModifiers.forEach(function(T) {
        var p = T.name, O = T.options, A = O === void 0 ? {} : O, o = T.effect;
        if (typeof o == "function") {
          var b = o({
            state: u,
            name: p,
            instance: D,
            options: A
          }), v = function() {
          };
          h.push(b || v);
        }
      });
    }
    function w() {
      h.forEach(function(T) {
        return T();
      }), h = [];
    }
    return D;
  };
}
var Ha = [fa, ka, ca, Vr, Pa, Oa, La, ia, Ta], ja = /* @__PURE__ */ Ua({
  defaultModifiers: Ha
}), Wa = "tippy-box", Ur = "tippy-content", Hr = "tippy-backdrop", jr = "tippy-arrow", Wr = "tippy-svg-arrow", Be = {
  passive: !0,
  capture: !0
}, Yr = function() {
  return document.body;
};
function _t(e, t, n) {
  if (Array.isArray(e)) {
    var a = e[t];
    return a ?? (Array.isArray(n) ? n[t] : n);
  }
  return e;
}
function ar(e, t) {
  var n = {}.toString.call(e);
  return n.indexOf("[object") === 0 && n.indexOf(t + "]") > -1;
}
function Xr(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function Dr(e, t) {
  if (t === 0)
    return e;
  var n;
  return function(a) {
    clearTimeout(n), n = setTimeout(function() {
      e(a);
    }, t);
  };
}
function Ya(e, t) {
  var n = Object.assign({}, e);
  return t.forEach(function(a) {
    delete n[a];
  }), n;
}
function Xa(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Ve(e) {
  return [].concat(e);
}
function Sr(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function qa(e) {
  return e.filter(function(t, n) {
    return e.indexOf(t) === n;
  });
}
function qr(e) {
  return e.split("-")[0];
}
function Je(e) {
  return [].slice.call(e);
}
function Or(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] !== void 0 && (t[n] = e[n]), t;
  }, {});
}
function $e() {
  return document.createElement("div");
}
function Vt(e) {
  return ["Element", "Fragment"].some(function(t) {
    return ar(e, t);
  });
}
function Ja(e) {
  return ar(e, "NodeList");
}
function or(e) {
  return ar(e, "MouseEvent");
}
function Ka(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function Ga(e) {
  return Vt(e) ? [e] : Ja(e) ? Je(e) : Array.isArray(e) ? e : Je(document.querySelectorAll(e));
}
function Ft(e, t) {
  e.forEach(function(n) {
    n && (n.style.transitionDuration = t + "ms");
  });
}
function dt(e, t) {
  e.forEach(function(n) {
    n && n.setAttribute("data-state", t);
  });
}
function Jr(e) {
  var t, n = Ve(e), a = n[0];
  return a != null && (t = a.ownerDocument) != null && t.body ? a.ownerDocument : document;
}
function Za(e, t) {
  var n = t.clientX, a = t.clientY;
  return e.every(function(r) {
    var i = r.popperRect, s = r.popperState, c = r.props, l = c.interactiveBorder, d = qr(s.placement), u = s.modifiersData.offset;
    if (!u)
      return !0;
    var h = d === "bottom" ? u.top.y : 0, S = d === "top" ? u.bottom.y : 0, D = d === "right" ? u.left.x : 0, y = d === "left" ? u.right.x : 0, w = i.top - a + h > l, T = a - i.bottom - S > l, p = i.left - n + D > l, O = n - i.right - y > l;
    return w || T || p || O;
  });
}
function zt(e, t, n) {
  var a = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(r) {
    e[a](r, n);
  });
}
function Er(e, t) {
  for (var n = t; n; ) {
    var a;
    if (e.contains(n))
      return !0;
    n = n.getRootNode == null || (a = n.getRootNode()) == null ? void 0 : a.host;
  }
  return !1;
}
var be = {
  isTouch: !1
}, Tr = 0;
function Qa() {
  be.isTouch || (be.isTouch = !0, window.performance && document.addEventListener("mousemove", Kr));
}
function Kr() {
  var e = performance.now();
  e - Tr < 20 && (be.isTouch = !1, document.removeEventListener("mousemove", Kr)), Tr = e;
}
function eo() {
  var e = document.activeElement;
  if (Ka(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function to() {
  document.addEventListener("touchstart", Qa, Be), window.addEventListener("blur", eo);
}
var ro = typeof window < "u" && typeof document < "u", no = ro ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, ao = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, oo = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, ge = Object.assign({
  appendTo: Yr,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, ao, oo), io = Object.keys(ge), so = function(t) {
  var n = Object.keys(t);
  n.forEach(function(a) {
    ge[a] = t[a];
  });
};
function Gr(e) {
  var t = e.plugins || [], n = t.reduce(function(a, r) {
    var i = r.name, s = r.defaultValue;
    if (i) {
      var c;
      a[i] = e[i] !== void 0 ? e[i] : (c = ge[i]) != null ? c : s;
    }
    return a;
  }, {});
  return Object.assign({}, e, n);
}
function lo(e, t) {
  var n = t ? Object.keys(Gr(Object.assign({}, ge, {
    plugins: t
  }))) : io, a = n.reduce(function(r, i) {
    var s = (e.getAttribute("data-tippy-" + i) || "").trim();
    if (!s)
      return r;
    if (i === "content")
      r[i] = s;
    else
      try {
        r[i] = JSON.parse(s);
      } catch {
        r[i] = s;
      }
    return r;
  }, {});
  return a;
}
function Cr(e, t) {
  var n = Object.assign({}, t, {
    content: Xr(t.content, [e])
  }, t.ignoreAttributes ? {} : lo(e, t.plugins));
  return n.aria = Object.assign({}, ge.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? t.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? t.interactive ? null : "describedby" : n.aria.content
  }, n;
}
var uo = function() {
  return "innerHTML";
};
function Xt(e, t) {
  e[uo()] = t;
}
function xr(e) {
  var t = $e();
  return e === !0 ? t.className = jr : (t.className = Wr, Vt(e) ? t.appendChild(e) : Xt(t, e)), t;
}
function Pr(e, t) {
  Vt(t.content) ? (Xt(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? Xt(e, t.content) : e.textContent = t.content);
}
function Rt(e) {
  var t = e.firstElementChild, n = Je(t.children);
  return {
    box: t,
    content: n.find(function(a) {
      return a.classList.contains(Ur);
    }),
    arrow: n.find(function(a) {
      return a.classList.contains(jr) || a.classList.contains(Wr);
    }),
    backdrop: n.find(function(a) {
      return a.classList.contains(Hr);
    })
  };
}
function Zr(e) {
  var t = $e(), n = $e();
  n.className = Wa, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var a = $e();
  a.className = Ur, a.setAttribute("data-state", "hidden"), Pr(a, e.props), t.appendChild(n), n.appendChild(a), r(e.props, e.props);
  function r(i, s) {
    var c = Rt(t), l = c.box, d = c.content, u = c.arrow;
    s.theme ? l.setAttribute("data-theme", s.theme) : l.removeAttribute("data-theme"), typeof s.animation == "string" ? l.setAttribute("data-animation", s.animation) : l.removeAttribute("data-animation"), s.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? l.setAttribute("role", s.role) : l.removeAttribute("role"), (i.content !== s.content || i.allowHTML !== s.allowHTML) && Pr(d, e.props), s.arrow ? u ? i.arrow !== s.arrow && (l.removeChild(u), l.appendChild(xr(s.arrow))) : l.appendChild(xr(s.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: t,
    onUpdate: r
  };
}
Zr.$$tippy = !0;
var co = 1, Tt = [], Nt = [];
function fo(e, t) {
  var n = Cr(e, Object.assign({}, ge, Gr(Or(t)))), a, r, i, s = !1, c = !1, l = !1, d = !1, u, h, S, D = [], y = Dr(me, n.interactiveDebounce), w, T = co++, p = null, O = qa(n.plugins), A = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, o = {
    // properties
    id: T,
    reference: e,
    popper: $e(),
    popperInstance: p,
    props: n,
    state: A,
    plugins: O,
    // methods
    clearDelayTimeouts: ht,
    setProps: yt,
    setContent: bt,
    show: tn,
    hide: rn,
    hideWithInteractivity: nn,
    enable: et,
    disable: gt,
    unmount: an,
    destroy: on
  };
  if (!n.render)
    return o;
  var b = n.render(o), v = b.popper, g = b.onUpdate;
  v.setAttribute("data-tippy-root", ""), v.id = "tippy-" + o.id, o.popper = v, e._tippy = o, v._tippy = o;
  var E = O.map(function(f) {
    return f.fn(o);
  }), R = e.hasAttribute("aria-expanded");
  return N(), oe(), z(), J("onCreate", [o]), n.showOnCreate && Qe(), v.addEventListener("mouseenter", function() {
    o.props.interactive && o.state.isVisible && o.clearDelayTimeouts();
  }), v.addEventListener("mouseleave", function() {
    o.props.interactive && o.props.trigger.indexOf("mouseenter") >= 0 && X().addEventListener("mousemove", y);
  }), o;
  function I() {
    var f = o.props.touch;
    return Array.isArray(f) ? f : [f, 0];
  }
  function _() {
    return I()[0] === "hold";
  }
  function B() {
    var f;
    return !!((f = o.props.render) != null && f.$$tippy);
  }
  function Y() {
    return w || e;
  }
  function X() {
    var f = Y().parentNode;
    return f ? Jr(f) : document;
  }
  function j() {
    return Rt(v);
  }
  function k(f) {
    return o.state.isMounted && !o.state.isVisible || be.isTouch || u && u.type === "focus" ? 0 : _t(o.props.delay, f ? 0 : 1, ge.delay);
  }
  function z(f) {
    f === void 0 && (f = !1), v.style.pointerEvents = o.props.interactive && !f ? "" : "none", v.style.zIndex = "" + o.props.zIndex;
  }
  function J(f, C, M) {
    if (M === void 0 && (M = !0), E.forEach(function(V) {
      V[f] && V[f].apply(V, C);
    }), M) {
      var U;
      (U = o.props)[f].apply(U, C);
    }
  }
  function G() {
    var f = o.props.aria;
    if (f.content) {
      var C = "aria-" + f.content, M = v.id, U = Ve(o.props.triggerTarget || e);
      U.forEach(function(V) {
        var Z = V.getAttribute(C);
        if (o.state.isVisible)
          V.setAttribute(C, Z ? Z + " " + M : M);
        else {
          var se = Z && Z.replace(M, "").trim();
          se ? V.setAttribute(C, se) : V.removeAttribute(C);
        }
      });
    }
  }
  function oe() {
    if (!(R || !o.props.aria.expanded)) {
      var f = Ve(o.props.triggerTarget || e);
      f.forEach(function(C) {
        o.props.interactive ? C.setAttribute("aria-expanded", o.state.isVisible && C === Y() ? "true" : "false") : C.removeAttribute("aria-expanded");
      });
    }
  }
  function Ee() {
    X().removeEventListener("mousemove", y), Tt = Tt.filter(function(f) {
      return f !== y;
    });
  }
  function ie(f) {
    if (!(be.isTouch && (l || f.type === "mousedown"))) {
      var C = f.composedPath && f.composedPath()[0] || f.target;
      if (!(o.props.interactive && Er(v, C))) {
        if (Ve(o.props.triggerTarget || e).some(function(M) {
          return Er(M, C);
        })) {
          if (be.isTouch || o.state.isVisible && o.props.trigger.indexOf("click") >= 0)
            return;
        } else
          J("onClickOutside", [o, f]);
        o.props.hideOnClick === !0 && (o.clearDelayTimeouts(), o.hide(), c = !0, setTimeout(function() {
          c = !1;
        }), o.state.isMounted || pe());
      }
    }
  }
  function Te() {
    l = !0;
  }
  function fe() {
    l = !1;
  }
  function ae() {
    var f = X();
    f.addEventListener("mousedown", ie, !0), f.addEventListener("touchend", ie, Be), f.addEventListener("touchstart", fe, Be), f.addEventListener("touchmove", Te, Be);
  }
  function pe() {
    var f = X();
    f.removeEventListener("mousedown", ie, !0), f.removeEventListener("touchend", ie, Be), f.removeEventListener("touchstart", fe, Be), f.removeEventListener("touchmove", Te, Be);
  }
  function Pe(f, C) {
    P(f, function() {
      !o.state.isVisible && v.parentNode && v.parentNode.contains(v) && C();
    });
  }
  function m(f, C) {
    P(f, C);
  }
  function P(f, C) {
    var M = j().box;
    function U(V) {
      V.target === M && (zt(M, "remove", U), C());
    }
    if (f === 0)
      return C();
    zt(M, "remove", h), zt(M, "add", U), h = U;
  }
  function L(f, C, M) {
    M === void 0 && (M = !1);
    var U = Ve(o.props.triggerTarget || e);
    U.forEach(function(V) {
      V.addEventListener(f, C, M), D.push({
        node: V,
        eventType: f,
        handler: C,
        options: M
      });
    });
  }
  function N() {
    _() && (L("touchstart", ve, {
      passive: !0
    }), L("touchend", _e, {
      passive: !0
    })), Xa(o.props.trigger).forEach(function(f) {
      if (f !== "manual")
        switch (L(f, ve), f) {
          case "mouseenter":
            L("mouseleave", _e);
            break;
          case "focus":
            L(no ? "focusout" : "blur", Ge);
            break;
          case "focusin":
            L("focusout", Ge);
            break;
        }
    });
  }
  function ee() {
    D.forEach(function(f) {
      var C = f.node, M = f.eventType, U = f.handler, V = f.options;
      C.removeEventListener(M, U, V);
    }), D = [];
  }
  function ve(f) {
    var C, M = !1;
    if (!(!o.state.isEnabled || Ze(f) || c)) {
      var U = ((C = u) == null ? void 0 : C.type) === "focus";
      u = f, w = f.currentTarget, oe(), !o.state.isVisible && or(f) && Tt.forEach(function(V) {
        return V(f);
      }), f.type === "click" && (o.props.trigger.indexOf("mouseenter") < 0 || s) && o.props.hideOnClick !== !1 && o.state.isVisible ? M = !0 : Qe(f), f.type === "click" && (s = !M), M && !U && Re(f);
    }
  }
  function me(f) {
    var C = f.target, M = Y().contains(C) || v.contains(C);
    if (!(f.type === "mousemove" && M)) {
      var U = Ae().concat(v).map(function(V) {
        var Z, se = V._tippy, Fe = (Z = se.popperInstance) == null ? void 0 : Z.state;
        return Fe ? {
          popperRect: V.getBoundingClientRect(),
          popperState: Fe,
          props: n
        } : null;
      }).filter(Boolean);
      Za(U, f) && (Ee(), Re(f));
    }
  }
  function _e(f) {
    var C = Ze(f) || o.props.trigger.indexOf("click") >= 0 && s;
    if (!C) {
      if (o.props.interactive) {
        o.hideWithInteractivity(f);
        return;
      }
      Re(f);
    }
  }
  function Ge(f) {
    o.props.trigger.indexOf("focusin") < 0 && f.target !== Y() || o.props.interactive && f.relatedTarget && v.contains(f.relatedTarget) || Re(f);
  }
  function Ze(f) {
    return be.isTouch ? _() !== f.type.indexOf("touch") >= 0 : !1;
  }
  function vt() {
    mt();
    var f = o.props, C = f.popperOptions, M = f.placement, U = f.offset, V = f.getReferenceClientRect, Z = f.moveTransition, se = B() ? Rt(v).arrow : null, Fe = V ? {
      getBoundingClientRect: V,
      contextElement: V.contextElement || Y()
    } : e, ir = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(wt) {
        var ze = wt.state;
        if (B()) {
          var sn = j(), $t = sn.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Dt) {
            Dt === "placement" ? $t.setAttribute("data-placement", ze.placement) : ze.attributes.popper["data-popper-" + Dt] ? $t.setAttribute("data-" + Dt, "") : $t.removeAttribute("data-" + Dt);
          }), ze.attributes.popper = {};
        }
      }
    }, Le = [{
      name: "offset",
      options: {
        offset: U
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Z
      }
    }, ir];
    B() && se && Le.push({
      name: "arrow",
      options: {
        element: se,
        padding: 3
      }
    }), Le.push.apply(Le, C?.modifiers || []), o.popperInstance = ja(Fe, v, Object.assign({}, C, {
      placement: M,
      onFirstUpdate: S,
      modifiers: Le
    }));
  }
  function mt() {
    o.popperInstance && (o.popperInstance.destroy(), o.popperInstance = null);
  }
  function Ce() {
    var f = o.props.appendTo, C, M = Y();
    o.props.interactive && f === Yr || f === "parent" ? C = M.parentNode : C = Xr(f, [M]), C.contains(v) || C.appendChild(v), o.state.isMounted = !0, vt();
  }
  function Ae() {
    return Je(v.querySelectorAll("[data-tippy-root]"));
  }
  function Qe(f) {
    o.clearDelayTimeouts(), f && J("onTrigger", [o, f]), ae();
    var C = k(!0), M = I(), U = M[0], V = M[1];
    be.isTouch && U === "hold" && V && (C = V), C ? a = setTimeout(function() {
      o.show();
    }, C) : o.show();
  }
  function Re(f) {
    if (o.clearDelayTimeouts(), J("onUntrigger", [o, f]), !o.state.isVisible) {
      pe();
      return;
    }
    if (!(o.props.trigger.indexOf("mouseenter") >= 0 && o.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(f.type) >= 0 && s)) {
      var C = k(!1);
      C ? r = setTimeout(function() {
        o.state.isVisible && o.hide();
      }, C) : i = requestAnimationFrame(function() {
        o.hide();
      });
    }
  }
  function et() {
    o.state.isEnabled = !0;
  }
  function gt() {
    o.hide(), o.state.isEnabled = !1;
  }
  function ht() {
    clearTimeout(a), clearTimeout(r), cancelAnimationFrame(i);
  }
  function yt(f) {
    if (!o.state.isDestroyed) {
      J("onBeforeUpdate", [o, f]), ee();
      var C = o.props, M = Cr(e, Object.assign({}, C, Or(f), {
        ignoreAttributes: !0
      }));
      o.props = M, N(), C.interactiveDebounce !== M.interactiveDebounce && (Ee(), y = Dr(me, M.interactiveDebounce)), C.triggerTarget && !M.triggerTarget ? Ve(C.triggerTarget).forEach(function(U) {
        U.removeAttribute("aria-expanded");
      }) : M.triggerTarget && e.removeAttribute("aria-expanded"), oe(), z(), g && g(C, M), o.popperInstance && (vt(), Ae().forEach(function(U) {
        requestAnimationFrame(U._tippy.popperInstance.forceUpdate);
      })), J("onAfterUpdate", [o, f]);
    }
  }
  function bt(f) {
    o.setProps({
      content: f
    });
  }
  function tn() {
    var f = o.state.isVisible, C = o.state.isDestroyed, M = !o.state.isEnabled, U = be.isTouch && !o.props.touch, V = _t(o.props.duration, 0, ge.duration);
    if (!(f || C || M || U) && !Y().hasAttribute("disabled") && (J("onShow", [o], !1), o.props.onShow(o) !== !1)) {
      if (o.state.isVisible = !0, B() && (v.style.visibility = "visible"), z(), ae(), o.state.isMounted || (v.style.transition = "none"), B()) {
        var Z = j(), se = Z.box, Fe = Z.content;
        Ft([se, Fe], 0);
      }
      S = function() {
        var Le;
        if (!(!o.state.isVisible || d)) {
          if (d = !0, v.offsetHeight, v.style.transition = o.props.moveTransition, B() && o.props.animation) {
            var It = j(), wt = It.box, ze = It.content;
            Ft([wt, ze], V), dt([wt, ze], "visible");
          }
          G(), oe(), Sr(Nt, o), (Le = o.popperInstance) == null || Le.forceUpdate(), J("onMount", [o]), o.props.animation && B() && m(V, function() {
            o.state.isShown = !0, J("onShown", [o]);
          });
        }
      }, Ce();
    }
  }
  function rn() {
    var f = !o.state.isVisible, C = o.state.isDestroyed, M = !o.state.isEnabled, U = _t(o.props.duration, 1, ge.duration);
    if (!(f || C || M) && (J("onHide", [o], !1), o.props.onHide(o) !== !1)) {
      if (o.state.isVisible = !1, o.state.isShown = !1, d = !1, s = !1, B() && (v.style.visibility = "hidden"), Ee(), pe(), z(!0), B()) {
        var V = j(), Z = V.box, se = V.content;
        o.props.animation && (Ft([Z, se], U), dt([Z, se], "hidden"));
      }
      G(), oe(), o.props.animation ? B() && Pe(U, o.unmount) : o.unmount();
    }
  }
  function nn(f) {
    X().addEventListener("mousemove", y), Sr(Tt, y), y(f);
  }
  function an() {
    o.state.isVisible && o.hide(), o.state.isMounted && (mt(), Ae().forEach(function(f) {
      f._tippy.unmount();
    }), v.parentNode && v.parentNode.removeChild(v), Nt = Nt.filter(function(f) {
      return f !== o;
    }), o.state.isMounted = !1, J("onHidden", [o]));
  }
  function on() {
    o.state.isDestroyed || (o.clearDelayTimeouts(), o.unmount(), ee(), delete e._tippy, o.state.isDestroyed = !0, J("onDestroy", [o]));
  }
}
function x(e, t) {
  t === void 0 && (t = {});
  var n = ge.plugins.concat(t.plugins || []);
  to();
  var a = Object.assign({}, t, {
    plugins: n
  }), r = Ga(e), i = r.reduce(function(s, c) {
    var l = c && fo(c, a);
    return l && s.push(l), s;
  }, []);
  return Vt(e) ? i[0] : i;
}
x.defaultProps = ge;
x.setDefaultProps = so;
x.currentInput = be;
var po = Object.assign({}, Vr, {
  effect: function(t) {
    var n = t.state, a = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, a.popper), n.styles = a, n.elements.arrow && Object.assign(n.elements.arrow.style, a.arrow);
  }
}), vo = function(t, n) {
  var a;
  n === void 0 && (n = {});
  var r = t, i = [], s = [], c, l = n.overrides, d = [], u = !1;
  function h() {
    s = r.map(function(o) {
      return Ve(o.props.triggerTarget || o.reference);
    }).reduce(function(o, b) {
      return o.concat(b);
    }, []);
  }
  function S() {
    i = r.map(function(o) {
      return o.reference;
    });
  }
  function D(o) {
    r.forEach(function(b) {
      o ? b.enable() : b.disable();
    });
  }
  function y(o) {
    return r.map(function(b) {
      var v = b.setProps;
      return b.setProps = function(g) {
        v(g), b.reference === c && o.setProps(g);
      }, function() {
        b.setProps = v;
      };
    });
  }
  function w(o, b) {
    var v = s.indexOf(b);
    if (b !== c) {
      c = b;
      var g = (l || []).concat("content").reduce(function(E, R) {
        return E[R] = r[v].props[R], E;
      }, {});
      o.setProps(Object.assign({}, g, {
        getReferenceClientRect: typeof g.getReferenceClientRect == "function" ? g.getReferenceClientRect : function() {
          var E;
          return (E = i[v]) == null ? void 0 : E.getBoundingClientRect();
        }
      }));
    }
  }
  D(!1), S(), h();
  var T = {
    fn: function() {
      return {
        onDestroy: function() {
          D(!0);
        },
        onHidden: function() {
          c = null;
        },
        onClickOutside: function(v) {
          v.props.showOnCreate && !u && (u = !0, c = null);
        },
        onShow: function(v) {
          v.props.showOnCreate && !u && (u = !0, w(v, i[0]));
        },
        onTrigger: function(v, g) {
          w(v, g.currentTarget);
        }
      };
    }
  }, p = x($e(), Object.assign({}, Ya(n, ["overrides"]), {
    plugins: [T].concat(n.plugins || []),
    triggerTarget: s,
    popperOptions: Object.assign({}, n.popperOptions, {
      modifiers: [].concat(((a = n.popperOptions) == null ? void 0 : a.modifiers) || [], [po])
    })
  })), O = p.show;
  p.show = function(o) {
    if (O(), !c && o == null)
      return w(p, i[0]);
    if (!(c && o == null)) {
      if (typeof o == "number")
        return i[o] && w(p, i[o]);
      if (r.indexOf(o) >= 0) {
        var b = o.reference;
        return w(p, b);
      }
      if (i.indexOf(o) >= 0)
        return w(p, o);
    }
  }, p.showNext = function() {
    var o = i[0];
    if (!c)
      return p.show(0);
    var b = i.indexOf(c);
    p.show(i[b + 1] || o);
  }, p.showPrevious = function() {
    var o = i[i.length - 1];
    if (!c)
      return p.show(o);
    var b = i.indexOf(c), v = i[b - 1] || o;
    p.show(v);
  };
  var A = p.setProps;
  return p.setProps = function(o) {
    l = o.overrides || l, A(o);
  }, p.setInstances = function(o) {
    D(!0), d.forEach(function(b) {
      return b();
    }), r = o, D(!1), S(), h(), d = y(p), p.setProps({
      triggerTarget: s
    });
  }, d = y(p), p;
}, mo = {
  name: "animateFill",
  defaultValue: !1,
  fn: function(t) {
    var n;
    if (!((n = t.props.render) != null && n.$$tippy))
      return {};
    var a = Rt(t.popper), r = a.box, i = a.content, s = t.props.animateFill ? go() : null;
    return {
      onCreate: function() {
        s && (r.insertBefore(s, r.firstElementChild), r.setAttribute("data-animatefill", ""), r.style.overflow = "hidden", t.setProps({
          arrow: !1,
          animation: "shift-away"
        }));
      },
      onMount: function() {
        if (s) {
          var l = r.style.transitionDuration, d = Number(l.replace("ms", ""));
          i.style.transitionDelay = Math.round(d / 10) + "ms", s.style.transitionDuration = l, dt([s], "visible");
        }
      },
      onShow: function() {
        s && (s.style.transitionDuration = "0ms");
      },
      onHide: function() {
        s && dt([s], "hidden");
      }
    };
  }
};
function go() {
  var e = $e();
  return e.className = Hr, dt([e], "hidden"), e;
}
var qt = {
  clientX: 0,
  clientY: 0
}, Ct = [];
function Qr(e) {
  var t = e.clientX, n = e.clientY;
  qt = {
    clientX: t,
    clientY: n
  };
}
function ho(e) {
  e.addEventListener("mousemove", Qr);
}
function yo(e) {
  e.removeEventListener("mousemove", Qr);
}
var bo = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(t) {
    var n = t.reference, a = Jr(t.props.triggerTarget || n), r = !1, i = !1, s = !0, c = t.props;
    function l() {
      return t.props.followCursor === "initial" && t.state.isVisible;
    }
    function d() {
      a.addEventListener("mousemove", S);
    }
    function u() {
      a.removeEventListener("mousemove", S);
    }
    function h() {
      r = !0, t.setProps({
        getReferenceClientRect: null
      }), r = !1;
    }
    function S(w) {
      var T = w.target ? n.contains(w.target) : !0, p = t.props.followCursor, O = w.clientX, A = w.clientY, o = n.getBoundingClientRect(), b = O - o.left, v = A - o.top;
      (T || !t.props.interactive) && t.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var E = n.getBoundingClientRect(), R = O, I = A;
          p === "initial" && (R = E.left + b, I = E.top + v);
          var _ = p === "horizontal" ? E.top : I, B = p === "vertical" ? E.right : R, Y = p === "horizontal" ? E.bottom : I, X = p === "vertical" ? E.left : R;
          return {
            width: B - X,
            height: Y - _,
            top: _,
            right: B,
            bottom: Y,
            left: X
          };
        }
      });
    }
    function D() {
      t.props.followCursor && (Ct.push({
        instance: t,
        doc: a
      }), ho(a));
    }
    function y() {
      Ct = Ct.filter(function(w) {
        return w.instance !== t;
      }), Ct.filter(function(w) {
        return w.doc === a;
      }).length === 0 && yo(a);
    }
    return {
      onCreate: D,
      onDestroy: y,
      onBeforeUpdate: function() {
        c = t.props;
      },
      onAfterUpdate: function(T, p) {
        var O = p.followCursor;
        r || O !== void 0 && c.followCursor !== O && (y(), O ? (D(), t.state.isMounted && !i && !l() && d()) : (u(), h()));
      },
      onMount: function() {
        t.props.followCursor && !i && (s && (S(qt), s = !1), l() || d());
      },
      onTrigger: function(T, p) {
        or(p) && (qt = {
          clientX: p.clientX,
          clientY: p.clientY
        }), i = p.type === "focus";
      },
      onHidden: function() {
        t.props.followCursor && (h(), u(), s = !0);
      }
    };
  }
};
function wo(e, t) {
  var n;
  return {
    popperOptions: Object.assign({}, e.popperOptions, {
      modifiers: [].concat((((n = e.popperOptions) == null ? void 0 : n.modifiers) || []).filter(function(a) {
        var r = a.name;
        return r !== t.name;
      }), [t])
    })
  };
}
var Do = {
  name: "inlinePositioning",
  defaultValue: !1,
  fn: function(t) {
    var n = t.reference;
    function a() {
      return !!t.props.inlinePositioning;
    }
    var r, i = -1, s = !1, c = [], l = {
      name: "tippyInlinePositioning",
      enabled: !0,
      phase: "afterWrite",
      fn: function(D) {
        var y = D.state;
        a() && (c.indexOf(y.placement) !== -1 && (c = []), r !== y.placement && c.indexOf(y.placement) === -1 && (c.push(y.placement), t.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function() {
            return d(y.placement);
          }
        })), r = y.placement);
      }
    };
    function d(S) {
      return So(qr(S), n.getBoundingClientRect(), Je(n.getClientRects()), i);
    }
    function u(S) {
      s = !0, t.setProps(S), s = !1;
    }
    function h() {
      s || u(wo(t.props, l));
    }
    return {
      onCreate: h,
      onAfterUpdate: h,
      onTrigger: function(D, y) {
        if (or(y)) {
          var w = Je(t.reference.getClientRects()), T = w.find(function(O) {
            return O.left - 2 <= y.clientX && O.right + 2 >= y.clientX && O.top - 2 <= y.clientY && O.bottom + 2 >= y.clientY;
          }), p = w.indexOf(T);
          i = p > -1 ? p : i;
        }
      },
      onHidden: function() {
        i = -1;
      }
    };
  }
};
function So(e, t, n, a) {
  if (n.length < 2 || e === null)
    return t;
  if (n.length === 2 && a >= 0 && n[0].left > n[1].right)
    return n[a] || t;
  switch (e) {
    case "top":
    case "bottom": {
      var r = n[0], i = n[n.length - 1], s = e === "top", c = r.top, l = i.bottom, d = s ? r.left : i.left, u = s ? r.right : i.right, h = u - d, S = l - c;
      return {
        top: c,
        bottom: l,
        left: d,
        right: u,
        width: h,
        height: S
      };
    }
    case "left":
    case "right": {
      var D = Math.min.apply(Math, n.map(function(v) {
        return v.left;
      })), y = Math.max.apply(Math, n.map(function(v) {
        return v.right;
      })), w = n.filter(function(v) {
        return e === "left" ? v.left === D : v.right === y;
      }), T = w[0].top, p = w[w.length - 1].bottom, O = D, A = y, o = A - O, b = p - T;
      return {
        top: T,
        bottom: p,
        left: O,
        right: A,
        width: o,
        height: b
      };
    }
    default:
      return t;
  }
}
var Oo = {
  name: "sticky",
  defaultValue: !1,
  fn: function(t) {
    var n = t.reference, a = t.popper;
    function r() {
      return t.popperInstance ? t.popperInstance.state.elements.reference : n;
    }
    function i(d) {
      return t.props.sticky === !0 || t.props.sticky === d;
    }
    var s = null, c = null;
    function l() {
      var d = i("reference") ? r().getBoundingClientRect() : null, u = i("popper") ? a.getBoundingClientRect() : null;
      (d && Ar(s, d) || u && Ar(c, u)) && t.popperInstance && t.popperInstance.update(), s = d, c = u, t.state.isMounted && requestAnimationFrame(l);
    }
    return {
      onMount: function() {
        t.props.sticky && l();
      }
    };
  }
};
function Ar(e, t) {
  return e && t ? e.top !== t.top || e.right !== t.right || e.bottom !== t.bottom || e.left !== t.left : !0;
}
x.setDefaultProps({
  render: Zr
});
x.setDefaultProps({
  //@ts-ignore
  onShow: (e) => {
    if (!e.props.content)
      return !1;
  }
});
const Eo = (e) => e instanceof Object && "$" in e && "$el" in e;
function To(e, t = {}, n = { mount: !0, appName: "Tippy" }) {
  n = Object.assign({ mount: !0, appName: "Tippy" }, n);
  const a = ln(), r = W(), i = W({
    isEnabled: !1,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  }), s = un();
  let c = null;
  const l = () => c || (c = document.createDocumentFragment(), c), d = (g) => {
    let E, R = ke(g) ? g.value : g;
    return cn(R) ? (s.value || (s.value = ur({
      name: n.appName,
      setup: () => () => ke(g) ? g.value : g
    }), a && Object.assign(s.value._context, a.appContext), s.value.mount(l())), E = () => l()) : typeof R == "object" ? (s.value || (s.value = ur({
      name: n.appName,
      setup: () => () => Ne(ke(g) ? g.value : g)
    }), a && Object.assign(s.value._context, a.appContext), s.value.mount(l())), E = () => l()) : E = R, E;
  }, u = (g) => {
    let E = {};
    return ke(g) ? E = g.value || {} : lr(g) ? E = { ...g } : E = { ...g }, E.content && (E.content = d(E.content)), E.triggerTarget && (E.triggerTarget = ke(E.triggerTarget) ? E.triggerTarget.value : E.triggerTarget), (!E.plugins || !Array.isArray(E.plugins)) && (E.plugins = []), E.plugins = E.plugins.filter((R) => R.name !== "vueTippyReactiveState"), E.plugins.push({
      name: "vueTippyReactiveState",
      fn: () => ({
        onCreate() {
          i.value.isEnabled = !0;
        },
        onMount() {
          i.value.isMounted = !0;
        },
        onShow() {
          i.value.isMounted = !0, i.value.isVisible = !0;
        },
        onShown() {
          i.value.isShown = !0;
        },
        onHide() {
          i.value.isMounted = !1, i.value.isVisible = !1;
        },
        onHidden() {
          i.value.isShown = !1;
        },
        onUnmounted() {
          i.value.isMounted = !1;
        },
        onDestroy() {
          i.value.isDestroyed = !0;
        }
      })
    }), E;
  }, h = () => {
    r.value && r.value.setProps(u(t));
  }, S = () => {
    !r.value || !t.content || r.value.setContent(d(t.content));
  }, D = (g) => {
    var E;
    (E = r.value) === null || E === void 0 || E.setContent(d(g));
  }, y = (g) => {
    var E;
    (E = r.value) === null || E === void 0 || E.setProps(u(g));
  }, w = () => {
    var g;
    r.value && (r.value.destroy(), r.value = void 0), c = null, (g = s.value) === null || g === void 0 || g.unmount(), s.value = void 0;
  }, T = () => {
    var g;
    (g = r.value) === null || g === void 0 || g.show();
  }, p = () => {
    var g;
    (g = r.value) === null || g === void 0 || g.hide();
  }, O = () => {
    var g;
    (g = r.value) === null || g === void 0 || g.disable(), i.value.isEnabled = !1;
  }, A = () => {
    var g;
    (g = r.value) === null || g === void 0 || g.enable(), i.value.isEnabled = !0;
  }, o = () => {
    var g;
    (g = r.value) === null || g === void 0 || g.unmount();
  }, b = () => {
    if (!e)
      return;
    let g = ke(e) ? e.value : e;
    typeof g == "function" && (g = g()), Eo(g) && (g = g.$el), g && (r.value = x(g, u(t)), g.$tippy = v);
  }, v = {
    tippy: r,
    refresh: h,
    refreshContent: S,
    setContent: D,
    setProps: y,
    destroy: w,
    hide: p,
    show: T,
    disable: O,
    enable: A,
    unmount: o,
    mount: b,
    state: i
  };
  return n.mount && (a ? a.isMounted ? b() : Kt(b) : b()), a && Mr(() => {
    w();
  }), ke(t) || lr(t) ? we(t, h, { immediate: !1 }) : ke(t.content) && we(t.content, S, { immediate: !1 }), v;
}
function Co(e, t) {
  const n = W();
  return Kt(() => {
    const r = (Array.isArray(e) ? e.map((i) => i.value) : typeof e == "function" ? e() : e.value).map((i) => i instanceof Element ? i._tippy : i).filter(Boolean);
    n.value = vo(r, t ? { allowHTML: !0, ...t } : { allowHTML: !0 });
  }), {
    singleton: n
  };
}
function xo(e) {
  return typeof e == "function" ? e() : $(e);
}
function Po(e) {
  var t, n;
  const a = xo(e);
  return (n = (t = a) === null || t === void 0 ? void 0 : t.$el) !== null && n !== void 0 ? n : a;
}
const Ao = Ke({
  props: {
    to: {
      type: [String, Function]
    },
    tag: {
      type: [String, Object],
      default: "span"
    },
    contentTag: {
      type: [String, Object],
      default: "span"
    },
    contentClass: {
      type: String,
      default: null
    },
    appendTo: { default: () => x.defaultProps.appendTo },
    aria: { default: () => x.defaultProps.aria },
    delay: { default: () => x.defaultProps.delay },
    duration: { default: () => x.defaultProps.duration },
    getReferenceClientRect: { default: () => x.defaultProps.getReferenceClientRect },
    hideOnClick: { type: [Boolean, String], default: () => x.defaultProps.hideOnClick },
    ignoreAttributes: { type: Boolean, default: () => x.defaultProps.ignoreAttributes },
    interactive: { type: Boolean, default: () => x.defaultProps.interactive },
    interactiveBorder: { default: () => x.defaultProps.interactiveBorder },
    interactiveDebounce: { default: () => x.defaultProps.interactiveDebounce },
    moveTransition: { default: () => x.defaultProps.moveTransition },
    offset: { default: () => x.defaultProps.offset },
    onAfterUpdate: { default: () => x.defaultProps.onAfterUpdate },
    onBeforeUpdate: { default: () => x.defaultProps.onBeforeUpdate },
    onCreate: { default: () => x.defaultProps.onCreate },
    onDestroy: { default: () => x.defaultProps.onDestroy },
    onHidden: { default: () => x.defaultProps.onHidden },
    onHide: { default: () => x.defaultProps.onHide },
    onMount: { default: () => x.defaultProps.onMount },
    onShow: { default: () => x.defaultProps.onShow },
    onShown: { default: () => x.defaultProps.onShown },
    onTrigger: { default: () => x.defaultProps.onTrigger },
    onUntrigger: { default: () => x.defaultProps.onUntrigger },
    onClickOutside: { default: () => x.defaultProps.onClickOutside },
    placement: { default: () => x.defaultProps.placement },
    plugins: { default: () => x.defaultProps.plugins },
    popperOptions: { default: () => x.defaultProps.popperOptions },
    render: { default: () => x.defaultProps.render },
    showOnCreate: { type: Boolean, default: () => x.defaultProps.showOnCreate },
    touch: { type: [Boolean, String, Array], default: () => x.defaultProps.touch },
    trigger: { default: () => x.defaultProps.trigger },
    triggerTarget: { default: () => x.defaultProps.triggerTarget },
    animateFill: { type: Boolean, default: () => x.defaultProps.animateFill },
    followCursor: { type: [Boolean, String], default: () => x.defaultProps.followCursor },
    inlinePositioning: { type: Boolean, default: () => x.defaultProps.inlinePositioning },
    sticky: { type: [Boolean, String], default: () => x.defaultProps.sticky },
    allowHTML: { type: Boolean, default: () => x.defaultProps.allowHTML },
    animation: { default: () => x.defaultProps.animation },
    arrow: { default: () => x.defaultProps.arrow },
    content: { default: () => x.defaultProps.content },
    inertia: { default: () => x.defaultProps.inertia },
    maxWidth: { default: () => x.defaultProps.maxWidth },
    role: { default: () => x.defaultProps.role },
    theme: { default: () => x.defaultProps.theme },
    zIndex: { default: () => x.defaultProps.zIndex }
  },
  emits: ["state"],
  setup(e, { slots: t, emit: n, expose: a }) {
    const r = W(), i = W(), s = W(), c = W(!1), l = () => {
      let D = { ...e };
      for (const y of ["to", "tag", "contentTag", "contentClass"])
        D.hasOwnProperty(y) && delete D[y];
      return D;
    };
    let d = () => Po(r);
    e.to && (typeof Element < "u" && e.to instanceof Element ? d = () => e.to : e.to === "parent" ? d = () => {
      let D = r.value;
      return D || (D = r.value = i.value.parentElement), D;
    } : (typeof e.to == "string" || e.to instanceof String) && (d = () => document.querySelector(e.to)));
    const u = To(d, l());
    let h = t.content;
    !h && e.to === "parent" && (h = t.default), Kt(() => {
      c.value = !0, st(() => {
        h && u.setContent(() => s.value);
      });
    }), we(u.state, () => {
      n("state", $(u.state));
    }, { immediate: !0, deep: !0 }), we(() => e, () => {
      u.setProps(l()), h && u.setContent(() => s.value);
    }, { deep: !0 });
    let S = Lt({
      elem: r,
      contentElem: s,
      mounted: c,
      ...u
    });
    return a(S), () => {
      const D = (typeof e.contentTag == "string", e.contentTag), y = h ? Ne(D, {
        ref: s,
        style: { display: c.value ? "inherit" : "none" },
        class: e.contentClass
      }, h(S)) : null;
      if (e.to === "parent") {
        const p = [];
        if (!r.value) {
          const O = Ne("span", {
            ref: i,
            "data-v-tippy": "",
            style: { display: "none" }
          });
          p.push(O);
        }
        return y && p.push(y), p;
      }
      const w = t.default ? t.default(S) : [];
      if (!e.tag) {
        const p = Ne(w[0], {
          ref: r,
          "data-v-tippy": ""
        });
        return y ? [p, y] : p;
      }
      const T = (typeof e.tag == "string", e.tag);
      return Ne(T, { ref: r, "data-v-tippy": "" }, y ? [w, y] : w);
    };
  }
}), ko = [
  "a11y",
  "allowHTML",
  "arrow",
  "flip",
  "flipOnUpdate",
  "hideOnClick",
  "ignoreAttributes",
  "inertia",
  "interactive",
  "lazy",
  "multiple",
  "showOnInit",
  "touch",
  "touchHold"
];
let Jt = {};
Object.keys(x.defaultProps).forEach((e) => {
  ko.includes(e) ? Jt[e] = {
    type: Boolean,
    default: function() {
      return x.defaultProps[e];
    }
  } : Jt[e] = {
    default: function() {
      return x.defaultProps[e];
    }
  };
});
Ke({
  props: Jt,
  setup(e) {
    const t = W([]), { singleton: n } = Co(t, e);
    return { instances: t, singleton: n };
  },
  mounted() {
    var e;
    const n = this.$el.parentElement.querySelectorAll("[data-v-tippy]");
    this.instances = Array.from(n).map((a) => a._tippy).filter(Boolean), (e = this.singleton) === null || e === void 0 || e.setInstances(this.instances);
  },
  render() {
    let e = this.$slots.default ? this.$slots.default() : [];
    return Ne(() => e);
  }
});
const en = x.setDefaultProps;
en({
  ignoreAttributes: !0,
  plugins: [Oo, Do, bo, mo]
});
const Mo = /* @__PURE__ */ Ke({
  __name: "ArboDateRangePicker",
  props: {
    label: {},
    modelValue: {},
    timezone: {},
    format: { default: "LLL dd" },
    placeholder: {},
    enableRangeFeedback: { type: Boolean },
    messages: {},
    isCompleted: { type: Boolean },
    isStarted: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    size: {},
    duePlaceholder: { default: "No due" },
    startPlaceholder: { default: "No start" },
    startTooltip: { default: "Select start date" },
    dueTooltip: { default: "Select due date" },
    showCalendarIcon: { type: Boolean, default: !0 },
    locale: { default: "en-US" }
  },
  emits: ["clearStart", "clearDue", "update", "update:start", "update:end", "range:invalid", "range:corrected", "tracing", "legacyUpdate"],
  setup(e, { expose: t, emit: n }) {
    en({
      // animation: 'shift-away-subtle',
      animation: "scale",
      duration: [100, 80]
    });
    const a = W({
      case: "",
      behavior: ""
    }), r = e, i = n, s = (j, k) => {
      j(), st(() => {
        k();
      });
    }, c = (j, k) => {
      j(), st(() => {
        k();
      });
    }, {
      states: l,
      tooltipStartDate: d,
      tooltipEndDate: u,
      selectEndDate: h,
      cancelSelection: S,
      confirmSelection: D,
      selectStartDate: y,
      clearDue: w,
      clearStart: T,
      beginInteraction: p
    } = Ln(r, i, a), O = q(() => {
      if (l.isSelectingStart) return "start";
      if (l.isSelectingEnd) return "end";
    }), A = q(() => l.isSelectingStart || l.isSelectingEnd);
    function o() {
      r.disabled || r.readonly || (p(), l.isSelectingStart = !0, l.isSelectingEnd = !1);
    }
    function b() {
      r.disabled || r.readonly || (p(), l.isSelectingEnd = !0, l.isSelectingStart = !1);
    }
    function v() {
      l.isSelectingStart = !1, l.isSelectingEnd = !1;
    }
    function g(j) {
      j.key === "Escape" && (j.stopPropagation(), v());
    }
    function E() {
      return document.body;
    }
    const R = W((/* @__PURE__ */ new Date()).getFullYear()), I = W((/* @__PURE__ */ new Date()).getMonth() + 1);
    we(
      () => [l.isSelectingStart, l.isSelectingEnd, l.startDate, l.endDate],
      () => {
        l.isSelectingStart && l.startDate ? (R.value = l.startDate.getFullYear(), I.value = l.startDate.getMonth() + 1) : l.isSelectingEnd && l.endDate && (R.value = l.endDate.getFullYear(), I.value = l.endDate.getMonth() + 1);
      },
      { immediate: !0 }
    );
    const _ = W(null);
    function B() {
      if (Array.isArray(r.modelValue)) {
        const [k, z] = r.modelValue;
        l.startDate = k || null, l.endDate = z || null;
      }
      l.isSelectingStart = !1, l.isSelectingEnd = !1;
      const j = l.startDate || l.endDate || /* @__PURE__ */ new Date();
      R.value = j.getFullYear(), I.value = j.getMonth() + 1;
    }
    we(
      () => [
        r.modelValue?.[0]?.getTime?.() || r.modelValue?.[0],
        r.modelValue?.[1]?.getTime?.() || r.modelValue?.[1],
        r.timezone,
        r.format,
        r.placeholder,
        r.enableRangeFeedback
      ],
      () => {
        B();
      },
      {
        immediate: !0,
        deep: !0
      }
    ), t({
      resetCalendarLogic: B,
      openStart: o,
      openEnd: b,
      closePicker: v,
      isOpen: A,
      drpRef: _
    });
    const Y = W(null);
    we(
      () => A.value,
      (j) => {
        if (r.disabled || r.readonly) return;
        const k = Y.value;
        k && (j ? k.show() : k.hide());
      },
      { immediate: !0 }
    );
    function X() {
      r.disabled || r.readonly || s(D, v);
    }
    return (j, k) => (te(), kt($(Ao), {
      ref_key: "tippyRef",
      ref: Y,
      theme: "light",
      trigger: "click",
      interactive: "",
      appendTo: E,
      hideOnClick: !1,
      onClickOutside: X,
      class: xe(["arbo-date-range-picker", {
        "is-selecting-start": $(l).isSelectingStart,
        "is-selecting-end": $(l).isSelectingEnd,
        "is-disabled": r.disabled,
        "is-readonly": r.readonly
      }])
    }, dn({
      default: rt(() => [
        r?.label ? (te(), kt($(wn), {
          key: 0,
          id: "date-range-label",
          class: "date-range__label",
          label: r?.label
        }, null, 8, ["label"])) : at("", !0),
        Q("div", {
          class: xe(["drp-trigger", { "is-disabled": r.disabled, "is-readonly": r.readonly }])
        }, [
          le(dr, {
            modelValue: $(l).startDate,
            "onUpdate:modelValue": k[0] || (k[0] = (z) => $(l).startDate = z),
            tooltip: $(d),
            active: $(l).isSelectingStart,
            format: r.format,
            placeholder: r.startPlaceholder,
            timezone: r.timezone,
            actual: e.isStarted,
            type: "start",
            disabled: r.disabled,
            readonly: r.readonly,
            showIcon: r.showCalendarIcon,
            size: r.size,
            onOpen: o,
            onClear: k[1] || (k[1] = (z) => s($(T), $(D)))
          }, null, 8, ["modelValue", "tooltip", "active", "format", "placeholder", "timezone", "actual", "disabled", "readonly", "showIcon", "size"]),
          le(dr, {
            "model-value": $(l).endDate,
            tooltip: $(u),
            active: $(l).isSelectingEnd,
            format: r.format,
            placeholder: r.duePlaceholder,
            timezone: r.timezone,
            actual: e.isCompleted,
            type: "end",
            disabled: r.disabled,
            readonly: r.readonly,
            showIcon: r.showCalendarIcon,
            size: r.size,
            onOpen: b,
            onClear: k[2] || (k[2] = (z) => s($(w), $(D)))
          }, null, 8, ["model-value", "tooltip", "active", "format", "placeholder", "timezone", "actual", "disabled", "readonly", "showIcon", "size"])
        ], 2)
      ]),
      _: 2
    }, [
      !r.disabled && !r.readonly ? {
        name: "content",
        fn: rt(() => [
          le(mn, {
            locale: r.locale,
            year: R.value,
            "onUpdate:year": k[7] || (k[7] = (z) => R.value = z),
            month: I.value,
            "onUpdate:month": k[8] || (k[8] = (z) => I.value = z),
            onKeydown: g
          }, {
            default: rt(({ year: z, month: J }) => [
              le(vn, {
                ref_key: "drpRef",
                ref: _,
                tracingCase: a.value,
                "onUpdate:tracingCase": k[3] || (k[3] = (G) => a.value = G),
                year: z,
                month: J,
                startDate: $(l).startDate,
                endDate: $(l).endDate,
                "active-field": O.value,
                timezone: r.timezone,
                onSelectStart: $(y),
                onSelectEnd: $(h),
                onConfirm: k[4] || (k[4] = (G) => s($(D), v)),
                onCancel: k[5] || (k[5] = (G) => c($(S), v)),
                onClose: k[6] || (k[6] = (G) => s($(D), v))
              }, null, 8, ["tracingCase", "year", "month", "startDate", "endDate", "active-field", "timezone", "onSelectStart", "onSelectEnd"])
            ]),
            _: 1
          }, 8, ["locale", "year", "month"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["class"]));
  }
}), Ro = /* @__PURE__ */ Gt(Mo, [["__scopeId", "data-v-cacce6ff"]]), xt = {
  STATUS: "status",
  DATE: "date",
  NONE: "none"
}, Lo = { class: "rc__content" }, Bo = {
  key: 0,
  class: "tess-report-card__text"
}, Vo = {
  key: 1,
  class: "tess-report-card__status"
}, Io = {
  key: 2,
  class: "tess-report-card__date"
}, Ki = /* @__PURE__ */ Ke({
  __name: "ReportCard",
  props: {
    statusProps: {
      type: Object,
      default: () => ({
        ...bn,
        ...yn,
        ...hn,
        isDark: !0
      })
    },
    datePickerCustomLabel: {
      type: String,
      default: "Completion date:"
    },
    isFormatDateDisplay: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: `Completed ${He({ code: "scene" })} Report`
    },
    subTitle: {
      type: String,
      default: `Download a report that includes the completed ${He({ code: "scene" })}.`
    },
    logo: {
      type: String,
      default: "ReportCompletedScenes"
    },
    isShowBackFlipTile: {
      type: Boolean,
      default: !1
    },
    minHeight: {
      type: String,
      default: "224px"
    },
    downloadBtnLabel: {
      type: String,
      default: "Download report"
    },
    description: {
      type: String,
      default: `Download a report that includes the completed ${He({ code: "scene" })}.`
    },
    reportType: {
      type: String,
      default: xt.NONE
    },
    format: {
      type: String,
      default: "yyyy-MM-dd"
    },
    startDate: {
      type: String,
      required: !0
    },
    endDate: {
      required: !0,
      type: String
    },
    timezone: {
      required: !0,
      type: String
    },
    customStatusSelect: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update-state-flip",
    "clicked-download-btn",
    "update:start-date",
    "update:due-date",
    "status:update-value",
    "status:update-raw-value",
    "status:load-more",
    "status:search",
    "status:shown",
    "status:hidden"
  ],
  setup(e, { emit: t }) {
    const n = e, a = t, r = (p) => {
      a("update-state-flip", p);
    }, i = () => {
      const p = {
        data: s.selectedData,
        start: n.startDate,
        end: n.endDate
      };
      a("clicked-download-btn", p);
    }, s = Lt({
      selectedData: null
    }), c = W(null), l = (p) => {
      if (!p) return null;
      const O = new Date(p);
      return isNaN(O.getTime()) ? null : O;
    }, d = W([l(n.startDate), l(n.endDate)]), u = (p) => {
      const [O, A] = p, o = (b) => b ? K.fromJSDate(b, { zone: n.timezone }).toUTC().toISO() : "";
      a("update:start-date", o(O)), a("update:due-date", o(A));
    }, h = (p) => {
      a("status:update-value", p);
    }, S = (p) => {
      a("status:update-raw-value", p);
    }, D = async () => {
      a("status:load-more");
    }, y = (p) => {
      a("status:search", p);
    }, w = () => {
      a("status:shown");
    }, T = () => {
      a("status:hidden");
    };
    return (p, O) => (te(), kt(Rn, cr({ class: "tess-report-card" }, n, {
      onUpdateStateFlip: r,
      onClickedDownloadBtn: i
    }), {
      content: rt(({ isShowBackFlipTile: A }) => [
        nt(p.$slots, "content", { isShowBackFlipTile: A }, () => [
          Q("div", Lo, [
            n.reportType === $(xt).NONE ? (te(), ye("div", Bo, lt(n.description), 1)) : n.reportType === $(xt).STATUS ? (te(), ye("div", Vo, [
              nt(p.$slots, "status-content", { isShowBackFlipTile: A }, () => [
                le(pn, cr({
                  label: "Status",
                  modelValue: s.selectedData,
                  "onUpdate:modelValue": O[0] || (O[0] = (o) => s.selectedData = o)
                }, n.statusProps, {
                  isStatusDisplayEnabled: !1,
                  useAbsolutePosition: !0,
                  customStatusSelect: e.customStatusSelect,
                  enableLimitTooltip: !0,
                  onLoadMore: D,
                  "onUpdate:modelValue": h,
                  "onUpdate:rawValue": S,
                  onSearch: y,
                  onShown: w,
                  onHidden: T,
                  ref_key: "statusSelectRef",
                  ref: c
                }), null, 16, ["modelValue", "customStatusSelect"])
              ], !0)
            ])) : n.reportType === $(xt).DATE ? (te(), ye("div", Io, [
              nt(p.$slots, "date-content", { isShowBackFlipTile: A }, () => [
                le(Ro, {
                  label: n.datePickerCustomLabel,
                  "model-value": d.value,
                  timezone: n.timezone,
                  format: n.format,
                  showCalendarIcon: !0,
                  startPlaceholder: "Start",
                  duePlaceholder: "Due",
                  isStarted: !1,
                  isCompleted: !1,
                  onUpdate: u
                }, null, 8, ["label", "model-value", "timezone", "format"])
              ], !0)
            ])) : at("", !0)
          ])
        ], !0)
      ]),
      _: 3
    }, 16));
  }
});
export {
  Ro as A,
  Rn as S,
  Ki as _,
  dr as a,
  He as g,
  Ji as u
};
